import { PostcodeDistrict } from '@leadgen/models/client'
export const districtCentroids: Record<PostcodeDistrict, [number, number]> = {
  AB10: [-2.116681870927694, 57.13904363582724],
  AB11: [-2.0901144295953418, 57.14097985665007],
  AB12: [-2.1019410916929693, 57.09102503765619],
  AB13: [-2.244899259259259, 57.107537592592585],
  AB14: [-2.2825823076923077, 57.10406200000001],
  AB15: [-2.1712655326460477, 57.142009759450126],
  AB16: [-2.154841896551725, 57.160583678160904],
  AB21: [-2.2026491139240516, 57.21877088607595],
  AB22: [-2.1188309244101893, 57.18347948468326],
  AB23: [-2.094722846034331, 57.21632100357455],
  AB24: [-2.11135989019798, 57.16402056793914],
  AB25: [-2.117494092827005, 57.15236957805906],
  AB30: [-2.4651070370370367, 56.848623148148164],
  AB31: [-2.5625982666666665, 57.08558786666665],
  AB32: [-2.354167435897436, 57.15380512820513],
  AB33: [-2.773219195402299, 57.2175567816092],
  AB34: [-2.8008564285714277, 57.094433571428596],
  AB35: [-3.170995777777777, 57.05162755555554],
  AB36: [-3.0931020930232562, 57.191503023255834],
  AB37: [-3.3644801851851835, 57.34855925925927],
  AB38: [-3.2271299999999994, 57.48479446153844],
  AB39: [-2.1983930836494694, 56.966485513498],
  AB41: [-2.0040375581581977, 57.362788499593336],
  AB42: [-1.8547464292886775, 57.468779886933866],
  AB43: [-2.0896977547219917, 57.668197412924506],
  AB44: [-2.4896660806828557, 57.67000156007782],
  AB45: [-2.554377658224995, 57.67159407124101],
  AB51: [-2.4412907305936065, 57.31460826484019],
  AB52: [-2.6094598850574724, 57.34657643678164],
  AB53: [-2.370866078431373, 57.51687411764707],
  AB54: [-2.7567713333333326, 57.45438744444446],
  AB55: [-3.004825853658535, 57.512728943089435],
  AB56: [-2.8924699548365287, 57.68781080353709],
  CW1: [-2.427766780821919, 53.101507876712304],
  CW2: [-2.423503837209301, 53.07854534883719],
  CW3: [-2.406968151260504, 52.99426537815126],
  CW4: [-2.351060326086956, 53.216656521739125],
  CW5: [-2.5214522784810107, 53.06425259493671],
  CW6: [-2.6636299295774646, 53.158861971831],
  CW7: [-2.5458515533980592, 53.182759514563124],
  CW8: [-2.577333184079601, 53.2503983084577],
  CW9: [-2.5056243396226403, 53.270468820754736],
  CW10: [-2.439936525423729, 53.1961318644068],
  CW11: [-2.350787291666668, 53.14238958333335],
  CW12: [-2.219504741379311, 53.1718345689655],
  HA0: [-0.3082979925650558, 51.55258111524161],
  HA1: [-0.339536276923077, 51.576967784615384],
  HA2: [-0.3606629023746703, 51.578965224274405],
  HA3: [-0.3189616577540104, 51.59438786096262],
  HA4: [-0.40581109890109895, 51.57128296703298],
  HA5: [-0.38595269624573375, 51.59350600682593],
  HA6: [-0.4200213669064748, 51.611690719424445],
  HA7: [-0.31086044520547934, 51.60899222602739],
  HA8: [-0.27368546125461246, 51.611127490774884],
  HA9: [-0.2884849130434782, 51.563255173913056],
  LN1: [-0.6185185058510816, 53.264499285105366],
  LN2: [-0.5182436322869953, 53.254478654708514],
  LN3: [-0.40836974683544286, 53.25350588607595],
  LN4: [-0.35407778242677806, 53.131329958159],
  LN5: [-0.5633886397058825, 53.1691161397059],
  LN6: [-0.6108863090128756, 53.19465360515019],
  LN7: [-0.34089040404040416, 53.490179898989865],
  LN8: [-0.33397742424242427, 53.35688292929293],
  LN9: [-0.11513282828282828, 53.221050303030324],
  LN10: [-0.21256514705882348, 53.1673607352941],
  LN11: [0.1365076037954754, 53.416988910629755],
  LN12: [0.24125351861274938, 53.348345090210735],
  LN13: [0.2034525390738961, 53.26995841660647],
  PO1: [-1.0908630633112484, 50.799274723178065],
  PO2: [-1.0785930788710538, 50.819296546943534],
  PO3: [-1.056378352309506, 50.818765899926696],
  PO4: [-1.0628452500103713, 50.791550122270415],
  PO5: [-1.0858872568469418, 50.78964048744442],
  PO6: [-1.0649232449558519, 50.84451925633099],
  PO7: [-1.045717277227723, 50.89022391089105],
  PO8: [-1.0111019841269844, 50.90958865079366],
  PO9: [-0.986112156448473, 50.859150558620485],
  PO10: [-0.9259993127534978, 50.83691459130904],
  PO11: [-0.9744895032790487, 50.80819404503531],
  PO12: [-1.1387027817117494, 50.79802565119025],
  PO13: [-1.1736864645920781, 50.81985079545323],
  PO14: [-1.2252168094096412, 50.84549964802727],
  PO15: [-1.2291356923076922, 50.86598599999999],
  PO16: [-1.1631855696370788, 50.85084517420154],
  PO17: [-1.1581727922077922, 50.88340714285716],
  PO18: [-0.8282476850256592, 50.84694373235621],
  PO19: [-0.7893611541822488, 50.83865559732642],
  PO20: [-0.789328560306388, 50.8032754708961],
  PO21: [-0.7082182874824233, 50.785500941869024],
  PO22: [-0.6589500912138248, 50.804164763413304],
  PO30: [-1.368461530094728, 50.70556945761441],
  PO31: [-1.3157671118825973, 50.74738959259858],
  PO32: [-1.2769919340736622, 50.74271201462571],
  PO33: [-1.1786159267278296, 50.71836988234162],
  PO34: [-1.115913164506675, 50.71818293966975],
  PO35: [-1.0940164707531421, 50.684133452085455],
  PO36: [-1.1725255517543933, 50.66164999861675],
  PO37: [-1.184042866489347, 50.63229057301558],
  PO38: [-1.2604657793992684, 50.61227949188128],
  PO39: [-1.5449843082964212, 50.6773935648487],
  PO40: [-1.521073567820365, 50.690194108801215],
  PO41: [-1.46560325437531, 50.703760459064796],
  TA1: [-3.1035494285714282, 51.01322935714287],
  TA2: [-3.0966487857142866, 51.036591571428566],
  TA3: [-3.0403387169551324, 50.98988476446486],
  TA4: [-3.273822444275684, 51.064798054032096],
  TA5: [-3.0711871128193233, 51.15770043231127],
  TA6: [-3.007323542064963, 51.1378334207889],
  TA7: [-2.9260730885114756, 51.10041000107704],
  TA8: [-3.007031283190751, 51.26564159625822],
  TA9: [-2.963307391896808, 51.22576517063771],
  TA10: [-2.8194470642201828, 51.02818366972478],
  TA11: [-2.689374270833333, 51.06418229166666],
  TA12: [-2.782835409836065, 50.979190327868835],
  TA13: [-2.8170340677966106, 50.946843389830526],
  TA14: [-2.7501671153846154, 50.94592211538462],
  TA15: [-2.7158434375, 50.95168562500001],
  TA16: [-2.7928293103448283, 50.910399310344836],
  TA17: [-2.84281425, 50.90655525000001],
  TA18: [-2.7895600943396244, 50.88417792452831],
  TA19: [-2.906791881188118, 50.93183702970298],
  TA20: [-2.977717655172414, 50.87837862068967],
  TA21: [-3.264367380952382, 50.977358809523786],
  TA22: [-3.55012154761905, 51.05758190476188],
  TA23: [-3.3696389816987766, 51.149504286949515],
  TA24: [-3.5459267463772868, 51.17226821421049],
  AL1: [-0.32533711026615963, 51.749759201520924],
  AL2: [-0.33832303448275863, 51.71785820689656],
  AL3: [-0.3712232954545453, 51.77465928030301],
  AL4: [-0.29505317391304325, 51.771278695652214],
  AL5: [-0.3549832323232325, 51.81886272727272],
  AL6: [-0.201983694267516, 51.8295131847134],
  AL7: [-0.1893287378640777, 51.79995116504855],
  AL8: [-0.21395142857142851, 51.805788666666665],
  AL9: [-0.19916792899408278, 51.75259130177515],
  AL10: [-0.23059186991869912, 51.762318617886166],
  DA1: [0.20863955670921283, 51.44914781705378],
  DA2: [0.2224208260982059, 51.43028353340317],
  DA3: [0.30169778846153855, 51.377704519230754],
  DA4: [0.23396773809523802, 51.3883430952381],
  DA5: [0.14761630769230777, 51.440131999999984],
  DA6: [0.14132129870129867, 51.45512240259739],
  DA7: [0.14557466192170815, 51.466224733096055],
  DA8: [0.1772904188067841, 51.47588116724205],
  DA9: [0.2783743985324847, 51.44801118519302],
  DA10: [0.306974896605212, 51.44699799061345],
  DA11: [0.3483952805855443, 51.43849776988525],
  DA12: [0.3880929388173328, 51.42172824486083],
  DA13: [0.35164337278106506, 51.38114863905325],
  DA14: [0.11132882022471913, 51.42635769662922],
  DA15: [0.0987913574660634, 51.44083628959276],
  DA16: [0.10699182432432433, 51.465429324324326],
  DA17: [0.14623616765083267, 51.48894946393477],
  DA18: [0.13754415384615384, 51.49427153846155],
  HD1: [-1.7921878846153851, 53.64750696153846],
  HD2: [-1.7856837254901967, 53.66577230392158],
  HD3: [-1.8407206400000007, 53.650759479999955],
  HD4: [-1.78869071942446, 53.62561010791362],
  HD5: [-1.7400593617021263, 53.65287207446809],
  HD6: [-1.7857502255639104, 53.70575120300751],
  HD7: [-1.868535677966102, 53.62785576271187],
  HD8: [-1.6898408074534168, 53.60870217391304],
  HD9: [-1.7890172807017546, 53.58054614035088],
  LS1: [-1.5477285714285713, 53.79769225563909],
  LS2: [-1.544838169642858, 53.80243071428571],
  LS3: [-1.5630373863636364, 53.80220852272728],
  LS4: [-1.5841929292929307, 53.81020060606059],
  LS5: [-1.6064029629629621, 53.8195468888889],
  LS6: [-1.5712995348837213, 53.82220943521595],
  LS7: [-1.540754922480621, 53.818102209302346],
  LS8: [-1.5113227407407401, 53.82339425925932],
  LS9: [-1.5081477232142848, 53.801204955357164],
  LS10: [-1.5328031550802135, 53.76870919786097],
  LS11: [-1.5574406289308174, 53.77928345911951],
  LS12: [-1.6002664253393661, 53.791213303167474],
  LS13: [-1.6385384848484845, 53.81021718614719],
  LS14: [-1.4562262992125992, 53.82872803149606],
  LS15: [-1.4432534825870644, 53.81244671641791],
  LS16: [-1.5996, 53.85013358585856],
  LS17: [-1.5229150657894743, 53.86751069078945],
  LS18: [-1.640888244274809, 53.84383870229008],
  LS19: [-1.6819269892473123, 53.859616666666675],
  LS20: [-1.7234154444444443, 53.87526277777777],
  LS21: [-1.674150272108843, 53.92487693877552],
  LS22: [-1.406573113207547, 53.93543330188679],
  LS23: [-1.3570652112676054, 53.89863056338027],
  LS24: [-1.2307383839484127, 53.86893383733132],
  LS25: [-1.306317092198582, 53.78444659574469],
  LS26: [-1.4453797159090909, 53.74744710227278],
  LS27: [-1.6059009600000003, 53.75038527999999],
  LS28: [-1.6689562694300528, 53.80685735751292],
  LS29: [-1.7987317094017092, 53.92248846153848],
  PR1: [-2.7043457644793, 53.757567362228365],
  PR2: [-2.7085948817285757, 53.77324173583305],
  PR3: [-2.8191087165636697, 53.88845694378814],
  PR4: [-2.837902480670214, 53.73904821414214],
  PR5: [-2.6492688642088775, 53.732275924264094],
  PR6: [-2.612179003984063, 53.67027868525897],
  PR7: [-2.6550660311284053, 53.64173556420233],
  PR8: [-2.998220457515309, 53.634050492096044],
  PR9: [-2.95439695931603, 53.68150727936862],
  PR25: [-2.694756495726496, 53.695597777777735],
  PR26: [-2.751484267886272, 53.687137714146616],
  TD1: [-2.807924711538462, 55.637983461538475],
  TD2: [-2.7370185106382974, 55.738417446808505],
  TD3: [-2.576202857142857, 55.70776775510201],
  TD4: [-2.664145111111111, 55.65273044444445],
  TD5: [-2.429932079207921, 55.57833128712873],
  TD6: [-2.714357850467289, 55.5751261682243],
  TD7: [-2.9513932954545457, 55.508476590909076],
  TD8: [-2.52484390625, 55.471374843749985],
  TD9: [-2.7965299999999993, 55.31229053763442],
  TD10: [-2.446329375, 55.71199708333333],
  TD11: [-2.350503711340206, 55.802985360824735],
  TD12: [-2.2272691780821923, 55.64628328767123],
  TD13: [-2.346233051807674, 55.931229627181686],
  TD14: [-2.137949812160734, 55.89033483951323],
  TD15: [-1.9803396089762317, 55.72678988428147],
  B1: [-1.90962294117647, 52.47953457516343],
  B2: [-1.8984949999999996, 52.479814838709665],
  B3: [-1.9041242990654208, 52.483265420560755],
  B4: [-1.8906849038461548, 52.48403461538463],
  B5: [-1.899772475728154, 52.467576893203876],
  B6: [-1.8862242631578965, 52.50707231578946],
  B7: [-1.8713047107438023, 52.49452735537189],
  B8: [-1.8422330128205129, 52.48952557692308],
  B9: [-1.8528588725490207, 52.4780258333333],
  B10: [-1.8528624647887328, 52.46978929577467],
  B11: [-1.8580491363636364, 52.45462886363634],
  B12: [-1.8842752659574475, 52.46034260638296],
  B13: [-1.882334503816793, 52.437437022900774],
  B14: [-1.8896605172413796, 52.418020068965504],
  B15: [-1.9272943636363633, 52.464790181818145],
  B16: [-1.9370299378881985, 52.47876527950313],
  B17: [-1.959437330097087, 52.46360883495147],
  B18: [-1.926581770833333, 52.49136411458332],
  B19: [-1.9064013580246917, 52.4968711728395],
  B20: [-1.9190921243523318, 52.51442569948188],
  B21: [-1.9371016312056728, 52.50620588652482],
  B23: [-1.8532958441558445, 52.52961476190472],
  B24: [-1.8283505617977527, 52.52076275280898],
  B25: [-1.8187223529411765, 52.46622941176466],
  B26: [-1.7875725984251962, 52.46003011811029],
  B27: [-1.8221474534161484, 52.44355732919254],
  B28: [-1.843812135416666, 52.42695401041666],
  B29: [-1.949121652542372, 52.43702046610171],
  B30: [-1.9239765454545448, 52.4210562181818],
  B31: [-1.9703683269961976, 52.41254007604565],
  B32: [-1.9957839903846162, 52.447035817307714],
  B33: [-1.7876059523809522, 52.47762928571431],
  B34: [-1.7849792700729925, 52.49647751824818],
  B35: [-1.788281739130435, 52.51839956521738],
  B36: [-1.7841816431924877, 52.50260699530514],
  B37: [-1.7455739568345323, 52.47828158273383],
  B38: [-1.9336505113636357, 52.40050954545454],
  B40: [-1.7170127272727271, 52.45396545454546],
  B42: [-1.914239506172839, 52.53429981481479],
  B43: [-1.9259663841807904, 52.548847231638405],
  B44: [-1.8846011111111114, 52.54564070707072],
  B45: [-2.005455496688742, 52.385290529801324],
  B46: [-1.6898037593984958, 52.50854721804512],
  B47: [-1.881488023255814, 52.38095546511629],
  B48: [-1.9332042592592589, 52.356738888888884],
  B49: [-1.8593365853658534, 52.2153769105691],
  B50: [-1.8501303636363642, 52.1681389090909],
  B60: [-2.0485695471698104, 52.33084773584904],
  B61: [-2.0714515652173913, 52.34352617391308],
  B62: [-2.0408643697478994, 52.44764592436971],
  B63: [-2.0719896045197745, 52.4551390960452],
  B64: [-2.0685829189189184, 52.47278729729728],
  B65: [-2.0434104736842107, 52.484348526315834],
  B66: [-1.9682684782608677, 52.49095152173912],
  B67: [-1.9793373333333342, 52.4846540888889],
  B68: [-2.0003510747663564, 52.47891355140187],
  B69: [-2.0316827235772363, 52.500677398373995],
  B70: [-2.009036822916667, 52.52384911458331],
  B71: [-1.992169281437126, 52.53592],
  B72: [-1.8223435000000001, 52.55132155555552],
  B73: [-1.8437642125984244, 52.55311807086617],
  B74: [-1.8507123456790124, 52.57987979423868],
  B75: [-1.812437547169811, 52.57858773584903],
  B76: [-1.7682081443298963, 52.545479896907224],
  B77: [-1.6688856603773583, 52.618796320754726],
  B78: [-1.686935536480687, 52.60080914163088],
  B79: [-1.6577541666666666, 52.65675506410256],
  B80: [-1.8813814444444446, 52.281440888888895],
  B90: [-1.827140968992247, 52.40087077519382],
  B91: [-1.7847154589371983, 52.41682285024158],
  B92: [-1.7741786292834902, 52.43557482866043],
  B93: [-1.732250760869565, 52.37371826086956],
  B94: [-1.8058442682926819, 52.35305335365855],
  B95: [-1.7804958536585365, 52.28125837398372],
  B96: [-1.9698292708333331, 52.24761385416668],
  B97: [-1.9546045402298846, 52.29730517241382],
  B98: [-1.9175417010309272, 52.30247798969072],
  DD1: [-2.9672469276826137, 56.46376701373895],
  DD2: [-3.044750767276284, 56.47049393397608],
  DD3: [-2.9924357499999994, 56.48370517857144],
  DD4: [-2.9385974403064403, 56.48594870300984],
  DD5: [-2.868740420856638, 56.48905470481901],
  DD6: [-2.9284791420847798, 56.42849099987937],
  DD7: [-2.736515089863152, 56.50146436526952],
  DD8: [-2.9217032835820884, 56.67159350746268],
  DD9: [-2.7175973529411763, 56.77436539215685],
  DD10: [-2.402639776843623, 56.75965840397982],
  DD11: [-2.557970249520848, 56.59486671823941],
  HG1: [-1.5314196984924635, 53.99850286432165],
  HG2: [-1.5255911520737333, 53.988660414746505],
  HG3: [-1.5852295555555556, 54.011770222222275],
  HG4: [-1.591488109756098, 54.17870365853656],
  HG5: [-1.448898823529412, 54.018111470588245],
  LU1: [-0.43262126436781595, 51.874443103448264],
  LU2: [-0.39592509615384613, 51.893035961538445],
  LU3: [-0.4375688127853883, 51.904647899543384],
  LU4: [-0.466891308411215, 51.899157383177574],
  LU5: [-0.5107400000000003, 51.90575322727274],
  LU6: [-0.5359990173410405, 51.87457057803468],
  LU7: [-0.6651462857142857, 51.89604278571429],
  RG1: [-0.9654913733905578, 51.45118965665233],
  RG2: [-0.9467275630252106, 51.421141218487385],
  RG4: [-0.9698509756097563, 51.48947175609758],
  RG5: [-0.9020711458333333, 51.450922708333316],
  RG6: [-0.9315742918454933, 51.44078309012877],
  RG7: [-1.077766344410876, 51.39320776435046],
  RG8: [-1.0960224064171125, 51.499140213903736],
  RG9: [-0.9371587603305782, 51.55561318181814],
  RG10: [-0.8512216556291394, 51.480932582781456],
  RG12: [-0.7557962626262626, 51.412564595959616],
  RG14: [-1.3190966272189357, 51.404901834319496],
  RG17: [-1.505259285714286, 51.430675857142866],
  RG18: [-1.2582372146118723, 51.42821908675802],
  RG19: [-1.2639524999999998, 51.38819030612243],
  RG20: [-1.3420370610687031, 51.41352851145037],
  RG21: [-1.091478125, 51.26487773437503],
  RG22: [-1.1196176595744673, 51.24967042553191],
  RG23: [-1.1443157971014488, 51.25810565217392],
  RG24: [-1.0790207534246572, 51.28174958904111],
  RG25: [-1.1209774175824176, 51.230506318681336],
  RG26: [-1.1426653987730055, 51.330954662576694],
  RG27: [-0.9353544549763032, 51.31038232227487],
  RG28: [-1.3415881012658228, 51.24303835443039],
  RG29: [-0.946278352941176, 51.236524470588215],
  RG30: [-1.024690981308411, 51.44320719626171],
  RG31: [-1.043334860335195, 51.45684044692739],
  RG40: [-0.836285051194539, 51.39461136518767],
  RG41: [-0.8637911999999999, 51.4138782857143],
  RG42: [-0.7524656818181822, 51.42894359090908],
  RG45: [-0.8026203409090911, 51.371090227272745],
  TF1: [-2.4896712154696132, 52.704391657458565],
  TF2: [-2.446916917293233, 52.70236496240603],
  TF3: [-2.451751153846153, 52.670090549450535],
  TF4: [-2.467456923076925, 52.66233669230768],
  TF5: [-2.537728833333334, 52.715785999999994],
  TF6: [-2.546697098214286, 52.72736325892856],
  TF7: [-2.452463818181819, 52.63647127272725],
  TF8: [-2.4775131538461532, 52.62681084615383],
  TF9: [-2.4830199425287343, 52.89443385057475],
  TF10: [-2.3915116037735844, 52.77306084905661],
  TF11: [-2.360527021276595, 52.65935241134752],
  TF12: [-2.481724999999999, 52.60699193548387],
  TF13: [-2.599944880952381, 52.56456666666666],
  BA1: [-2.3599601811594217, 51.39546130434784],
  BA2: [-2.3747716489361697, 51.35746566489366],
  BA3: [-2.4730590673575135, 51.27213704663211],
  BA4: [-2.53226701986755, 51.15992649006624],
  BA5: [-2.6654954054054056, 51.22137567567569],
  BA6: [-2.7046113559322023, 51.13903694915255],
  BA7: [-2.5248644927536223, 51.08472217391304],
  BA8: [-2.409945735294117, 51.00194500000001],
  BA9: [-2.4095139830508474, 51.06005923728813],
  BA10: [-2.4355436363636365, 51.117556060606056],
  BA11: [-2.34496588235294, 51.23956980392157],
  BA12: [-2.203413677419356, 51.14326993548391],
  BA13: [-2.189474356435644, 51.263470198019796],
  BA14: [-2.1877481395348837, 51.322634806201556],
  BA15: [-2.268339891304349, 51.358218586956504],
  BA16: [-2.7502537254901958, 51.13041960784315],
  BA20: [-2.647183533333335, 50.93980566666668],
  BA21: [-2.6435390588235284, 50.95072447058824],
  BA22: [-2.6345909756097545, 50.967733728223],
  DE1: [-1.4821138912133887, 52.92297163179918],
  DE3: [-1.540690125, 52.90626849999999],
  DE4: [-1.5706409999999997, 53.11917723076921],
  DE5: [-1.4106041509433955, 53.038854622641495],
  DE6: [-1.7182126446280992, 52.97041111570248],
  DE7: [-1.345430121212121, 52.97462036363634],
  DE11: [-1.5532787128712875, 52.77350257425743],
  DE12: [-1.5730692622950815, 52.726147131147535],
  DE13: [-1.7049723557692302, 52.804891538461526],
  DE14: [-1.642515909090908, 52.80683553030302],
  DE15: [-1.6002490298507457, 52.798007910447765],
  DE21: [-1.4407671584699453, 52.94232076502733],
  DE22: [-1.4971115562913908, 52.92937728476822],
  DE23: [-1.4957476804123715, 52.90356685567011],
  DE24: [-1.4583946153846148, 52.89171549450549],
  DE45: [-1.6830723076923084, 53.21070846153848],
  DE55: [-1.3795272289156628, 53.10789765060239],
  DE56: [-1.4895211976047908, 53.025346586826366],
  DE65: [-1.620819180327869, 52.86719245901639],
  DE72: [-1.3555816312056737, 52.89288446808508],
  DE73: [-1.4575887121212117, 52.84677613636366],
  DE74: [-1.3191495588235285, 52.83563044117645],
  DE75: [-1.3503409195402292, 53.013151609195425],
  HP1: [-0.49631258823529384, 51.757731529411764],
  HP2: [-0.4580700000000003, 51.76259112149536],
  HP3: [-0.4708084362139919, 51.7360306995885],
  HP4: [-0.5672220512820512, 51.77865735042737],
  HP5: [-0.6030987586206903, 51.71521627586207],
  HP6: [-0.5960726219512197, 51.67842079268289],
  HP7: [-0.6024189873417722, 51.666585063291144],
  HP8: [-0.5633434831460674, 51.64594112359553],
  HP9: [-0.6371024242424244, 51.609400151515175],
  HP10: [-0.701155302325581, 51.613986000000025],
  HP11: [-0.7405622302158273, 51.62215312949638],
  HP12: [-0.7785886163522008, 51.62912735849056],
  HP13: [-0.7386296911196916, 51.630891312741305],
  HP14: [-0.8260314024390245, 51.651412926829295],
  HP15: [-0.7162006542056075, 51.6568163551402],
  HP16: [-0.7179300990099008, 51.70627297029701],
  HP17: [-0.8469886805555559, 51.77333569444447],
  HP18: [-0.9887546202531641, 51.81898525316454],
  HP19: [-0.8207951388888893, 51.823017638888864],
  HP20: [-0.8024596685082872, 51.81957839779],
  HP21: [-0.8042155629139068, 51.80825059602646],
  HP22: [-0.7946349781659389, 51.818334192139744],
  HP23: [-0.657376, 51.79338490909089],
  HP27: [-0.8341254216867469, 51.714664698795175],
  M1: [-2.236548423645321, 53.47804753694581],
  M2: [-2.2446805, 53.479393899999984],
  M3: [-2.251921885714287, 53.48362377142858],
  M4: [-2.230262196531792, 53.48533231213873],
  M5: [-2.2935711858974357, 53.481089775641045],
  M6: [-2.3011868100358424, 53.49177451612903],
  M7: [-2.2620154545454536, 53.50440047619048],
  M8: [-2.2429715693430654, 53.51017408759123],
  M9: [-2.212443682008369, 53.519947029288694],
  M11: [-2.1784353886010366, 53.477801088082906],
  M12: [-2.2033563984674305, 53.46517191570879],
  M13: [-2.214828115384615, 53.45980011538464],
  M14: [-2.222595232558139, 53.448122790697695],
  M15: [-2.2495623626373624, 53.46573346153842],
  M16: [-2.2657852569169967, 53.454588458498044],
  M17: [-2.3162939999999996, 53.46733190909088],
  M18: [-2.1715530344827583, 53.46085165517242],
  M19: [-2.1988861923076923, 53.432403538461486],
  M20: [-2.2316638095238095, 53.42477590476191],
  M21: [-2.2681928160919522, 53.43856109195402],
  M22: [-2.2600334554973824, 53.38525785340314],
  M23: [-2.291379194312796, 53.39990582938388],
  M24: [-2.191531902173913, 53.55053347826088],
  M25: [-2.2692978409090903, 53.530763863636366],
  M26: [-2.3420256213017745, 53.561866863905344],
  M27: [-2.338288410256412, 53.50914056410255],
  M28: [-2.3944908510638294, 53.51525051063826],
  M29: [-2.4609645238095235, 53.5055450793651],
  M30: [-2.360920691823901, 53.48329496855346],
  M31: [-2.411984888888889, 53.42313377777777],
  M32: [-2.3126685029940126, 53.45241712574847],
  M33: [-2.3218670526315788, 53.41551452631581],
  M34: [-2.1284073684210543, 53.460611271929835],
  M35: [-2.1554633333333326, 53.50565749999999],
  M38: [-2.41916744, 53.53102591999998],
  M40: [-2.188880738461538, 53.50558295384617],
  M41: [-2.3607423717948737, 53.4538851923077],
  M43: [-2.150795192307694, 53.48268596153845],
  M44: [-2.4307968807339457, 53.43854110091746],
  M45: [-2.289389573170733, 53.54736371951225],
  M46: [-2.490616847826086, 53.52408804347824],
  M50: [-2.30225731884058, 53.47742688405797],
  M90: [-2.278650816326531, 53.36491122448979],
  RH1: [-0.15529048913043483, 51.236350923913044],
  RH2: [-0.20585826086956518, 51.230772445652164],
  RH3: [-0.2719481333333334, 51.23415346666666],
  RH4: [-0.3341320967741935, 51.22635362903229],
  RH5: [-0.3474094814814814, 51.207991074074044],
  RH6: [-0.16072098214285716, 51.16684089285716],
  RH7: [-0.0250806976744186, 51.17670220930231],
  RH8: [0.00020608695652173827, 51.24610144927536],
  RH9: [-0.06006756756756756, 51.22398945945946],
  RH10: [-0.15955492957746475, 51.118508356807524],
  RH11: [-0.19839948863636356, 51.115157045454545],
  RH12: [-0.3441772834645673, 51.08285145669291],
  RH13: [-0.3225699207618655, 51.030221857346405],
  RH14: [-0.49403159759189813, 51.03384545665059],
  RH15: [-0.12990208333333328, 50.957577500000006],
  RH16: [-0.09393714285714287, 50.999164821428565],
  RH17: [-0.10410290441176477, 51.0122931617647],
  RH18: [0.0335421052631579, 51.08774228070174],
  RH19: [-0.01713830508474576, 51.11891864406778],
  RH20: [-0.5124494030919252, 50.94452081261892],
  TN1: [0.26722088435374153, 51.13507979591838],
  TN2: [0.2811592477876106, 51.13716557522123],
  TN3: [0.2563448106060604, 51.12166393939394],
  TN4: [0.25481088983050837, 51.142825974576276],
  TN5: [0.35963940476190487, 51.0592855952381],
  TN6: [0.2012641489361702, 51.05437542553193],
  TN7: [0.10179051724137934, 51.09969741379309],
  TN8: [0.09475418803418802, 51.193093076923084],
  TN9: [0.2755410909090908, 51.19580554545456],
  TN10: [0.28162441860465115, 51.20917937984496],
  TN11: [0.26797192810457504, 51.200020620915026],
  TN12: [0.4417430456852791, 51.17665472081217],
  TN13: [0.18242688888888872, 51.28187577777777],
  TN14: [0.15103153024911029, 51.2946440569395],
  TN15: [0.27463444954128446, 51.3042696788991],
  TN16: [0.06755295081967212, 51.28612106557378],
  TN17: [0.5441342592592591, 51.0988514197531],
  TN18: [0.544089090909091, 51.03750727272729],
  TN19: [0.41134918918918917, 51.00520513513514],
  TN20: [0.25134125000000007, 51.01533486111111],
  TN21: [0.27918725, 50.95168741666669],
  TN22: [0.09209496644295304, 50.99046812080535],
  TN23: [0.8583441477272724, 51.13979738636363],
  TN24: [0.8818305911330054, 51.15285211822661],
  TN25: [0.9169156410256404, 51.150066442307676],
  TN26: [0.8077321105527641, 51.10708909547738],
  TN27: [0.6932163190184047, 51.165479325153356],
  TN28: [0.945698312793664, 50.97893378810797],
  TN29: [0.9272875348082071, 51.00236448637114],
  TN30: [0.7028559999999998, 51.05532322222221],
  TN31: [0.7068857648948348, 50.95609209672028],
  TN32: [0.47938873786407776, 50.97470194174759],
  TN33: [0.46548392, 50.90767887999998],
  TN34: [0.5825771074432249, 50.87091088032442],
  TN35: [0.6093135620115834, 50.88481582563738],
  TN36: [0.6904528175451005, 50.92068007059645],
  TN37: [0.5551964603650027, 50.873877037870415],
  TN38: [0.5432646963218543, 50.87053735954134],
  TN39: [0.45711815895787195, 50.85097150471002],
  TN40: [0.4813599346269573, 50.847932686177415],
  BB1: [-2.465042398373983, 53.752494024390245],
  BB2: [-2.5009447413793104, 53.74564499999998],
  BB3: [-2.4733682051282053, 53.708420512820496],
  BB4: [-2.285048582677166, 53.704601338582684],
  BB5: [-2.370018141592922, 53.75810300884958],
  BB6: [-2.4254352808988773, 53.799310561797746],
  BB7: [-2.388289264705882, 53.88095029411763],
  BB8: [-2.160983369565218, 53.858929673913046],
  BB9: [-2.227102793296091, 53.84185927374303],
  BB10: [-2.214461893203884, 53.80007019417477],
  BB11: [-2.2568301149425296, 53.77978477011494],
  BB12: [-2.2863998484848493, 53.80893959595959],
  BB18: [-2.162559818181818, 53.91010418181816],
  DG1: [-3.522729101776504, 55.012055104731644],
  DG2: [-3.636565931225912, 55.00005406706054],
  DG3: [-3.842855322580645, 55.23778661290323],
  DG4: [-3.935008717948717, 55.38386589743588],
  DG5: [-3.789429427676843, 54.88329455890423],
  DG6: [-4.09439261542171, 54.80059928173786],
  DG7: [-4.017907835996716, 54.87046380655206],
  DG8: [-4.460238579283525, 54.826593216727645],
  DG9: [-5.0350946977696625, 54.82878698033366],
  DG10: [-3.4236007692307693, 55.3117076923077],
  DG11: [-3.330196217948718, 55.11660371794873],
  DG12: [-3.25535815279618, 54.976150397473205],
  DG13: [-3.093712962962964, 55.21258074074075],
  DG14: [-2.994192878787879, 55.0810953030303],
  DG16: [-3.0694556860958984, 54.98659948749864],
  HR1: [-2.653800112359553, 52.05638224719099],
  HR2: [-2.7897964173228345, 51.99439472440944],
  HR3: [-3.0729480916030547, 52.102020610687035],
  HR4: [-2.7803677727272698, 52.097767136363636],
  HR5: [-3.0533369473684195, 52.18679757894737],
  HR6: [-2.7950158857142853, 52.234294399999996],
  HR7: [-2.529670917431193, 52.18771816513762],
  HR8: [-2.4646966874999996, 52.04785931249999],
  HR9: [-2.5858636516853934, 51.901042921348335],
  ME1: [0.4840800183582223, 51.357790476187006],
  ME2: [0.48005555714611486, 51.38402227829149],
  ME3: [0.6059634025858204, 51.43474260478455],
  ME4: [0.5314188339008469, 51.381656605597904],
  ME5: [0.5362637083333333, 51.35940316666665],
  ME6: [0.4439396057240045, 51.328598845181936],
  ME7: [0.5646128626881368, 51.37669604784025],
  ME8: [0.603721611470864, 51.37139172068316],
  ME9: [0.7217090690059363, 51.36536990294216],
  ME10: [0.7412715234180627, 51.349304026538086],
  ME11: [0.7249572416870558, 51.41161149378202],
  ME12: [0.8310205793111525, 51.38859831016293],
  ME13: [0.8867721038640308, 51.31575268734062],
  ME14: [0.5472514883720931, 51.284936976744184],
  ME15: [0.5208072327044023, 51.252287106918196],
  ME16: [0.49935348502652066, 51.27492508693675],
  ME17: [0.5949075984251969, 51.23494976377951],
  ME18: [0.4081334108527133, 51.24409837209302],
  ME19: [0.40822770186335394, 51.29574099378882],
  ME20: [0.46543922050483433, 51.30845237925487],
  RM1: [0.18415282258064508, 51.58375423387098],
  RM2: [0.20294801324503323, 51.584598278145684],
  RM3: [0.22264750000000005, 51.59858612068965],
  RM4: [0.18049281553398058, 51.63891155339803],
  RM5: [0.16573120805369124, 51.59672422818793],
  RM6: [0.1273239024390244, 51.57583504065041],
  RM7: [0.16844717073170729, 51.5764292682927],
  RM8: [0.13124142105263154, 51.55671752631575],
  RM9: [0.13698748337184333, 51.539235501076334],
  RM10: [0.15588993827160486, 51.54482148148146],
  RM11: [0.21399535999999997, 51.57067832],
  RM12: [0.2073300000000001, 51.554781893203874],
  RM13: [0.1902911868151398, 51.52463757518632],
  RM14: [0.2828104026845638, 51.55556033557047],
  RM15: [0.2597324787896994, 51.504631623669596],
  RM16: [0.33450126436781613, 51.49286252873562],
  RM17: [0.3259181697822825, 51.48056627959475],
  RM18: [0.386630155236898, 51.46919074507623],
  RM19: [0.2456325728343997, 51.48385642584427],
  RM20: [0.28634454354312006, 51.47633352280489],
  TQ1: [-3.519882193935028, 50.47891509645133],
  TQ2: [-3.5400665199259156, 50.47458233252586],
  TQ3: [-3.577601292479212, 50.44284350457684],
  TQ4: [-3.5712913387661636, 50.423190250532336],
  TQ5: [-3.533353724707034, 50.390596167508086],
  TQ6: [-3.5720436508387685, 50.34981938582496],
  TQ7: [-3.7975082930544404, 50.260666256114895],
  TQ8: [-3.761794303085064, 50.23080288009386],
  TQ9: [-3.6788945104161868, 50.4090134108497],
  TQ10: [-3.8181614285714267, 50.423357999999986],
  TQ11: [-3.7987747619047636, 50.48306126984128],
  TQ12: [-3.6062949233504886, 50.53269436513838],
  TQ13: [-3.7210829718875473, 50.58819152610441],
  TQ14: [-3.5184878199600185, 50.54907403069652],
  BD1: [-1.7549367261904747, 53.79769154761906],
  BD2: [-1.7374317937219743, 53.81625273542601],
  BD3: [-1.7296802762430932, 53.79993900552484],
  BD4: [-1.7144017061611372, 53.77507881516588],
  BD5: [-1.7593843103448275, 53.77754275862066],
  BD6: [-1.7867725541125528, 53.76581484848485],
  BD7: [-1.7844570048309196, 53.78300734299516],
  BD8: [-1.785026814516129, 53.802071008064516],
  BD9: [-1.7905088333333345, 53.81262783333331],
  BD10: [-1.725140487804877, 53.830321524390214],
  BD11: [-1.6756111009174308, 53.75415366972477],
  BD12: [-1.763035403225806, 53.747085806451615],
  BD13: [-1.851775, 53.78650259433966],
  BD14: [-1.8182492592592592, 53.782593086419766],
  BD15: [-1.835527539682539, 53.80779603174601],
  BD16: [-1.8348766929133862, 53.84836440944881],
  BD17: [-1.7644416535433067, 53.846287716535414],
  BD18: [-1.7728821319796944, 53.8309453807107],
  BD19: [-1.711588253968254, 53.72855809523811],
  BD20: [-1.9361888524590156, 53.88876016393442],
  BD21: [-1.912202264150943, 53.8619012830189],
  BD22: [-1.9566040975609755, 53.857291463414604],
  BD23: [-2.0973263586956516, 54.02102239130436],
  BD24: [-2.27995054054054, 54.09740013513516],
  DH1: [-1.5630705468750001, 54.77626445312498],
  DH2: [-1.5983565806451614, 54.86047270967741],
  DH3: [-1.5603212954886434, 54.86959884427066],
  DH4: [-1.4946022246928468, 54.85129832829001],
  DH5: [-1.463595054945055, 54.82602153846152],
  DH6: [-1.4795961320754714, 54.75232174528305],
  DH7: [-1.68017993902439, 54.79052932926832],
  DH8: [-1.9077533636363633, 54.853547545454546],
  DH9: [-1.6973041964285713, 54.87157598214281],
  HS1: [-6.381677741246937, 58.21129500536091],
  HS2: [-6.627336092454561, 58.21425124248599],
  HS3: [-6.903642158783898, 57.90047845407805],
  HS4: [-6.6871727975388815, 57.8646904713714],
  HS5: [-7.030706697212688, 57.74067198908168],
  HS6: [-7.23507986312813, 57.59205809654217],
  HS7: [-7.259159820582837, 57.42620523397291],
  HS8: [-7.296327837484064, 57.23462485907368],
  HS9: [-7.4802369334842025, 56.953265631269],
  MK1: [-0.7280626388888888, 52.00632694444445],
  MK2: [-0.7256830487804876, 51.99012585365852],
  MK3: [-0.7525078832116792, 51.994060072992696],
  MK4: [-0.7810866406249998, 52.00591734375],
  MK5: [-0.7869589130434782, 52.02025818840578],
  MK6: [-0.739844642857143, 52.029365357142865],
  MK7: [-0.6935355670103095, 52.019070515463916],
  MK8: [-0.8027395876288661, 52.03329350515461],
  MK9: [-0.7576697247706415, 52.041267155963304],
  MK10: [-0.696928735632184, 52.03859126436782],
  MK11: [-0.8372608333333332, 52.05109722222222],
  MK12: [-0.818148139534884, 52.05726372093022],
  MK13: [-0.7819231623931624, 52.05370854700853],
  MK14: [-0.7571238235294115, 52.06241698529409],
  MK15: [-0.7285758558558556, 52.05438189189186],
  MK16: [-0.7167277241379307, 52.100299241379304],
  MK17: [-0.7276069283276461, 51.99247177474397],
  MK18: [-0.9542687573964492, 51.96531094674555],
  MK19: [-0.843805780346821, 52.06362589595371],
  MK40: [-0.4727413586956521, 52.13835385869566],
  MK41: [-0.455427832512315, 52.1515680295566],
  MK42: [-0.4713854666666666, 52.115952133333344],
  MK43: [-0.5664040322580648, 52.12004149193552],
  MK44: [-0.4231964552238807, 52.194862500000006],
  MK45: [-0.457594556962025, 52.03781487341771],
  MK46: [-0.6951689333333332, 52.15268306666665],
  S1: [-1.4721761403508766, 53.379591754385956],
  S2: [-1.4521746020761246, 53.36832179930799],
  S3: [-1.4764494852941175, 53.385358602941125],
  S4: [-1.4525340983606547, 53.400505409836015],
  S5: [-1.4635364516129024, 53.42169100806456],
  S6: [-1.5169733070866143, 53.40194633858272],
  S7: [-1.4919712440191382, 53.35517043062206],
  S8: [-1.476451302521009, 53.34654634453782],
  S9: [-1.4189621229050275, 53.40251474860334],
  S10: [-1.5151732684824901, 53.375830038910486],
  S11: [-1.5111056338028166, 53.35946595070426],
  S12: [-1.4049550980392154, 53.34720127450979],
  S13: [-1.3866867105263159, 53.36442236842104],
  S14: [-1.4448216842105264, 53.3484796842105],
  S17: [-1.5262386301369864, 53.31883273972602],
  S18: [-1.4808984, 53.29457560000001],
  S20: [-1.3586014393939392, 53.33519825757576],
  S21: [-1.3459775000000003, 53.309986339285715],
  S25: [-1.2241768750000004, 53.36963062500001],
  S26: [-1.2881255652173909, 53.35074191304348],
  S32: [-1.6616881538461536, 53.298466615384605],
  S33: [-1.7522597959183674, 53.36740653061225],
  S35: [-1.5035781339712915, 53.454879377990444],
  S36: [-1.632783229166667, 53.513692916666656],
  S40: [-1.4508072881355938, 53.234623813559296],
  S41: [-1.42613805907173, 53.24284856540085],
  S42: [-1.446925611510792, 53.21325960431648],
  S43: [-1.3501140000000007, 53.26818516129032],
  S44: [-1.3350245890410954, 53.222707876712306],
  S45: [-1.4335910691823897, 53.16658968553459],
  S60: [-1.348431966527196, 53.419986108786645],
  S61: [-1.3939605000000002, 53.44380783333335],
  S62: [-1.371180956521739, 53.46862408695654],
  S63: [-1.3392988652482272, 53.514080851063824],
  S64: [-1.302505666666667, 53.487902],
  S65: [-1.3145169777777768, 53.435380399999985],
  S66: [-1.2447555999999997, 53.42012720000002],
  S70: [-1.4760063963963956, 53.54027202702703],
  S71: [-1.4523303333333337, 53.5666430952381],
  S72: [-1.3767554310344827, 53.57227905172416],
  S73: [-1.3911223469387752, 53.52034438775511],
  S74: [-1.4440386075949367, 53.500730253164555],
  S75: [-1.5177349350649356, 53.5529471861472],
  S80: [-1.1528039759036155, 53.29019638554217],
  S81: [-1.1223226623376619, 53.339606233766226],
  TR1: [-5.042867486806783, 50.25661941354511],
  TR2: [-4.969654407160827, 50.213168308643695],
  TR3: [-5.088200296287664, 50.21818425647318],
  TR4: [-5.14054030242921, 50.28065498151121],
  TR5: [-5.2012156351855765, 50.317708717983585],
  TR6: [-5.157916200984648, 50.34147286134537],
  TR7: [-5.081807244835216, 50.41463563364903],
  TR8: [-5.065913952196358, 50.4111692479683],
  TR9: [-4.935280344827586, 50.42041298850576],
  TR10: [-5.1314047714355, 50.16579195379221],
  TR11: [-5.102473615866451, 50.13821636307052],
  TR12: [-5.180642453841376, 50.0318721894724],
  TR13: [-5.300320113520848, 50.11893355924242],
  TR14: [-5.304204571216751, 50.212058235952384],
  TR15: [-5.2429895121951215, 50.23255780487805],
  TR16: [-5.234431768871426, 50.23794589398358],
  TR17: [-5.468386465912506, 50.12616007309121],
  TR18: [-5.54440160769538, 50.11722860302165],
  TR19: [-5.652364152835946, 50.08526008337835],
  TR20: [-5.514224020438966, 50.13227483111733],
  TR26: [-5.527451386943452, 50.201131854037165],
  TR27: [-5.401675886686719, 50.20082038074445],
  BH1: [-1.8582162820117858, 50.72634793282815],
  BH2: [-1.883073285952523, 50.72277175161674],
  BH3: [-1.8811910810810806, 50.73686873873872],
  BH4: [-1.8983284626, 50.72216291680982],
  BH5: [-1.8320446352494377, 50.726553705318736],
  BH6: [-1.789145978785192, 50.72850641112376],
  BH7: [-1.826710275862069, 50.735912620689646],
  BH8: [-1.8553451587301595, 50.74039091269843],
  BH9: [-1.8706817857142868, 50.74936438775506],
  BH10: [-1.894501117647058, 50.757831235294134],
  BH11: [-1.9155546323529418, 50.75798713235293],
  BH12: [-1.9273883913043486, 50.73685778260867],
  BH13: [-1.9314126775446965, 50.70775202324651],
  BH14: [-1.9457586438247956, 50.7212962619999],
  BH15: [-1.9980184011121276, 50.714449664716184],
  BH16: [-2.052319093580486, 50.72633371501123],
  BH17: [-1.985758219631997, 50.74667051017479],
  BH18: [-1.9994836885245904, 50.757579754098366],
  BH19: [-1.9779307306767988, 50.63422164086459],
  BH20: [-2.076238321100373, 50.675711913778024],
  BH21: [-1.961528171206225, 50.82738124513622],
  BH22: [-1.88950623931624, 50.80469880341879],
  BH23: [-1.7700190431154845, 50.744851944147115],
  BH24: [-1.7923214529914528, 50.843701623931636],
  BH25: [-1.655615974785481, 50.7612561922937],
  BH31: [-1.8740769565217383, 50.87569326086956],
  DL1: [-1.5443824796747967, 54.537584756097594],
  DL2: [-1.6147971826625394, 54.53473860681107],
  DL3: [-1.5668687984496121, 54.53678666666668],
  DL4: [-1.643142153846154, 54.63300815384614],
  DL5: [-1.5876888311688315, 54.61651402597402],
  DL6: [-1.3882888157894717, 54.3669585526316],
  DL7: [-1.4826712446351928, 54.34156957081549],
  DL8: [-1.762883760683762, 54.2849273931624],
  DL9: [-1.7086242372881353, 54.371814067796635],
  DL10: [-1.6832939999999996, 54.409381161290305],
  DL11: [-1.85382577777778, 54.44616533333329],
  DL12: [-1.9937943518518522, 54.58079583333333],
  DL13: [-1.9132008771929825, 54.71263695906434],
  DL14: [-1.6982440490797555, 54.659510184049076],
  DL15: [-1.7231579629629623, 54.714620740740756],
  DL16: [-1.610225060240964, 54.69718602409636],
  DL17: [-1.538027870370371, 54.673365277777805],
  HU1: [-0.3395777448866219, 53.74316966447246],
  HU2: [-0.3407895096532314, 53.750435987990876],
  HU3: [-0.3622831116724342, 53.746251186055986],
  HU4: [-0.4065036470970449, 53.737623885771214],
  HU5: [-0.3732047444127522, 53.759245703550114],
  HU6: [-0.3616590551266792, 53.77991799634288],
  HU7: [-0.33254864932614064, 53.78613491285622],
  HU8: [-0.30503919775412836, 53.766474082872584],
  HU9: [-0.29469648902694595, 53.756601847017365],
  HU10: [-0.4367024999999999, 53.75065925],
  HU11: [-0.20821406594202105, 53.83276846462051],
  HU12: [-0.06954341133511441, 53.68381287681365],
  HU13: [-0.43276429504249725, 53.72680562048453],
  HU14: [-0.5081765611760103, 53.73116381349721],
  HU15: [-0.632265340097356, 53.74405487587943],
  HU16: [-0.4339054022988507, 53.7814788505747],
  HU17: [-0.40453161971100976, 53.86009203293439],
  HU18: [-0.16500769823986636, 53.900879521126456],
  HU19: [0.02726050308705766, 53.7114523440579],
  HU20: [-0.5283781250000001, 53.787425625000004],
  ML1: [-3.9710597883597902, 55.8027144444444],
  ML2: [-3.9114908771929815, 55.77481166666666],
  ML3: [-4.061482676056339, 55.76791619718308],
  ML4: [-4.021571067961165, 55.820703009708716],
  ML5: [-4.0322147445255485, 55.865926642335765],
  ML6: [-3.960986581196582, 55.870832051282036],
  ML7: [-3.8079928846153854, 55.839306923076904],
  ML8: [-3.846191265822786, 55.724114936708865],
  ML9: [-3.9599418421052626, 55.7171485526316],
  ML10: [-4.101711166666666, 55.66562883333333],
  ML11: [-3.768412357142857, 55.66903942857142],
  ML12: [-3.627761428571428, 55.54190464285714],
  SA1: [-3.937982549681696, 51.63101266296151],
  SA2: [-4.00724284758734, 51.619413291687735],
  SA3: [-4.192400058714037, 51.60160216945754],
  SA4: [-4.078521018357456, 51.66590877050643],
  SA5: [-3.9708528799999985, 51.66052632000001],
  SA6: [-3.9246468341708542, 51.675545075376924],
  SA7: [-3.8939165605095525, 51.665157388535064],
  SA8: [-3.850348170731709, 51.72878353658533],
  SA9: [-3.761630555555555, 51.78744066666667],
  SA10: [-3.799222212085935, 51.67946677932327],
  SA11: [-3.7686869509499177, 51.67381154575876],
  SA12: [-3.7844462944725903, 51.61262539505988],
  SA13: [-3.7339326199474994, 51.59966362485018],
  SA14: [-4.105266483559485, 51.716341494097925],
  SA15: [-4.167199996629525, 51.705525662551615],
  SA16: [-4.279816650157298, 51.69066445439802],
  SA17: [-4.3313740598624015, 51.73264914409797],
  SA18: [-3.9776424806201547, 51.801962635658924],
  SA19: [-3.9514262121212123, 51.95956550505049],
  SA20: [-3.7969181012658213, 52.014884430379745],
  SA31: [-4.3002490484588645, 51.852645971182056],
  SA32: [-4.221505388969439, 51.86556212618313],
  SA33: [-4.443378825414677, 51.80538465031145],
  SA34: [-4.622757796610173, 51.849673474576285],
  SA35: [-4.560489516129033, 51.96295387096773],
  SA36: [-4.605042, 51.958657599999995],
  SA37: [-4.595668307692307, 52.01460892307693],
  SA38: [-4.487339278350515, 52.04711319587632],
  SA39: [-4.242350588235295, 52.02143838235293],
  SA40: [-4.188436025641024, 52.087232948717954],
  SA41: [-4.7124381443299, 51.9949524742268],
  SA42: [-4.868345082537539, 52.02353153828794],
  SA43: [-4.654370521411024, 52.10646043046589],
  SA44: [-4.408474831788075, 52.13077632807948],
  SA45: [-4.364090031228098, 52.2054019026116],
  SA46: [-4.255347593469271, 52.23647841458937],
  SA47: [-4.297728723082036, 52.194332795594946],
  SA48: [-4.120923382352942, 52.154288602941165],
  SA61: [-4.969197352000128, 51.79817676781928],
  SA62: [-5.168786845500356, 51.81704433272486],
  SA63: [-4.85417352112676, 51.88033098591549],
  SA64: [-5.0467343928852495, 52.01424215021057],
  SA65: [-4.947959742693821, 51.99210978862403],
  SA66: [-4.757598539325844, 51.89987191011238],
  SA67: [-4.7802560947711, 51.77567685844296],
  SA68: [-4.836499493517318, 51.7227583519674],
  SA69: [-4.702350248986949, 51.70724395091996],
  SA70: [-4.75494401964442, 51.65636085543303],
  SA71: [-4.998004889229761, 51.651556205584164],
  SA72: [-4.916138485061181, 51.695454369758565],
  SA73: [-5.0157476915950685, 51.72007290667743],
  TS1: [-1.2416283921636742, 54.57101040541965],
  TS2: [-1.2060987206883396, 54.5980753161769],
  TS3: [-1.1991291835588187, 54.56554593828978],
  TS4: [-1.2232906937691375, 54.558439959258685],
  TS5: [-1.2491727809509816, 54.55436057576216],
  TS6: [-1.1604118211394974, 54.57311543318579],
  TS7: [-1.1855881325301203, 54.5344460240964],
  TS8: [-1.2256289147286823, 54.52263186046508],
  TS9: [-1.1661443564356437, 54.445722871287124],
  TS10: [-1.1024610407755464, 54.61153228886542],
  TS11: [-1.0342368880979562, 54.58518421137932],
  TS12: [-0.9574567946306902, 54.55214806303708],
  TS13: [-0.8223449598874742, 54.54544453400458],
  TS14: [-1.067981403508772, 54.53649175438596],
  TS15: [-1.343374211873669, 54.490960410923535],
  TS16: [-1.3705702149791503, 54.512379915433165],
  TS17: [-1.3082619149985033, 54.53575926776011],
  TS18: [-1.3213997737745315, 54.55967720304949],
  TS19: [-1.3427265128205121, 54.57428415384616],
  TS20: [-1.3135420119376673, 54.586586575195184],
  TS21: [-1.4013401219512198, 54.60119939024391],
  TS22: [-1.3029724626865677, 54.631081044776124],
  TS23: [-1.2769807695734936, 54.6034024324713],
  TS24: [-1.2174722730707905, 54.695694199913625],
  TS25: [-1.2110001779043076, 54.64251242374357],
  TS26: [-1.2296942682926826, 54.689049329268315],
  TS27: [-1.2891394234127884, 54.71597284624418],
  TS28: [-1.372224375, 54.71517859375],
  TS29: [-1.418178235294118, 54.7112956862745],
  BL0: [-2.320341180124224, 53.64334900621122],
  BL1: [-2.442665156950673, 53.58964946188344],
  BL2: [-2.3991178571428575, 53.58662487394959],
  BL3: [-2.4237417518248177, 53.56539489051093],
  BL4: [-2.4051007734806635, 53.546814585635325],
  BL5: [-2.504006041666667, 53.54900409722223],
  BL6: [-2.535378811188811, 53.58628412587413],
  BL7: [-2.4218861607142865, 53.63267053571429],
  BL8: [-2.3331065581395345, 53.62066037209304],
  BL9: [-2.2890756164383554, 53.59232566210047],
  DN1: [-1.1301370085470084, 53.52275470085472],
  DN2: [-1.1034893635410559, 53.535640517550085],
  DN3: [-1.0597939852193614, 53.54509383474892],
  DN4: [-1.1249187192118233, 53.50686566502464],
  DN5: [-1.2020726315789476, 53.54656688995217],
  DN6: [-1.167212695874491, 53.603793274207156],
  DN7: [-1.0153455932163247, 53.588800260899255],
  DN8: [-0.9494662125435572, 53.610994784237235],
  DN9: [-0.846753962438769, 53.49982848786272],
  DN10: [-0.9147820944699943, 53.42650313060353],
  DN11: [-1.099394017094017, 53.45652914529913],
  DN12: [-1.231820652173913, 53.48056304347826],
  DN14: [-0.9158228528996972, 53.707533266316936],
  DN15: [-0.6451612123531751, 53.62943666347942],
  DN16: [-0.6414441044776119, 53.56877141791044],
  DN17: [-0.7115470290817181, 53.58445044063855],
  DN18: [-0.4852988987755564, 53.67591549621915],
  DN19: [-0.3398297069970834, 53.69268186846766],
  DN20: [-0.4937609000000001, 53.568698299999994],
  DN21: [-0.7279130768038506, 53.40872197872502],
  DN22: [-0.8644938135390879, 53.32021191762694],
  DN31: [-0.0868999685838295, 53.572266656623796],
  DN32: [-0.0680916894977169, 53.56316625570772],
  DN33: [-0.10008642105263156, 53.54028663157893],
  DN34: [-0.10843000000000003, 53.558292062499994],
  DN35: [-0.03964308911531193, 53.55208557938142],
  DN36: [0.0494520124961721, 53.50443243483769],
  DN37: [-0.1568956621004566, 53.54150913242008],
  DN38: [-0.385178596491228, 53.55602035087719],
  DN39: [-0.3425388679245281, 53.61865528301885],
  DN40: [-0.23351780925388105, 53.63473107218711],
  DN41: [-0.19587902837728693, 53.58612077512899],
  HX1: [-1.8750569101123604, 53.720592808988705],
  HX2: [-1.9020619303797468, 53.7309124683544],
  HX3: [-1.8481368266666673, 53.7293176],
  HX4: [-1.8893064062500007, 53.673430312499995],
  HX5: [-1.8336898666666661, 53.68509266666666],
  HX6: [-1.9260361184210528, 53.69814355263158],
  HX7: [-2.0189782142857142, 53.73550809523811],
  N1: [-0.09576322891566258, 51.53714214457828],
  N1C: [-0.1267152459016393, 51.53659983606557],
  N2: [-0.16944464285714286, 51.58788928571431],
  N3: [-0.19300556213017733, 51.6005830177515],
  N4: [-0.10529237226277371, 51.569764343065714],
  N5: [-0.0989218784530387, 51.553339060773475],
  N6: [-0.14615032967032976, 51.57394357142855],
  N7: [-0.11961301829268295, 51.553614999999965],
  N8: [-0.11504755208333335, 51.583877864583364],
  N9: [-0.06307282926829269, 51.62982473170728],
  N10: [-0.14535441860465118, 51.59375372093022],
  N11: [-0.14114878306878306, 51.61555925925927],
  N12: [-0.17823122340425532, 51.613618085106395],
  N13: [-0.10629759825327507, 51.618291921397386],
  N14: [-0.12919113122171938, 51.633884343891445],
  N15: [-0.08303460905349794, 51.583745349794235],
  N16: [-0.07499761764705883, 51.56263011764701],
  N17: [-0.07471392241379311, 51.59730474137933],
  N18: [-0.06854685863874348, 51.614139685863854],
  N19: [-0.13096017730496465, 51.56300716312059],
  N20: [-0.17678256157635466, 51.62916448275861],
  N21: [-0.09964613756613754, 51.63638185185189],
  N22: [-0.11179394495412853, 51.60028688073397],
  SE1: [-0.08657745040724592, 51.493484048290895],
  SE2: [0.11896497483103315, 51.488870756487856],
  SE3: [0.021554722222222208, 51.469207182539684],
  SE4: [-0.03482301507537689, 51.46239422110553],
  SE5: [-0.09053809523809528, 51.47451931547622],
  SE6: [-0.01589638554216867, 51.43776184738958],
  SE7: [0.03636620712290189, 51.4843392952796],
  SE8: [-0.028614082215715562, 51.47876390436485],
  SE9: [0.057130039682539664, 51.44433365079369],
  SE10: [-0.004473069117786085, 51.48082416733008],
  SE11: [-0.11166440993788819, 51.48956080745342],
  SE12: [0.019029999999999988, 51.44324756906079],
  SE13: [-0.011451985559566788, 51.460921444043294],
  SE14: [-0.04112115207373272, 51.47481170506912],
  SE15: [-0.06425600682593859, 51.47170846416383],
  SE16: [-0.05748538093008178, 51.49351482392794],
  SE17: [-0.09377553398058251, 51.48771441747573],
  SE18: [0.06881277525767972, 51.48263683681079],
  SE19: [-0.08739579710144928, 51.41797478260872],
  SE20: [-0.058883290322580634, 51.41253509677421],
  SE21: [-0.08815299999999998, 51.439868263157884],
  SE22: [-0.07166156976744185, 51.45463244186049],
  SE23: [-0.048227000000000006, 51.44155142105261],
  SE24: [-0.1016958673469387, 51.45499010204081],
  SE25: [-0.07851783549783552, 51.39702207792209],
  SE26: [-0.05104502590673574, 51.426881295336806],
  SE27: [-0.10241301587301584, 51.43122539682538],
  SE28: [0.10081966008938223, 51.498479943568725],
  TW1: [-0.32968180597087005, 51.44841104216823],
  TW2: [-0.35720314009661835, 51.447441304347834],
  TW3: [-0.36606942622950805, 51.46762036885245],
  TW4: [-0.38623737068965497, 51.4643732327586],
  TW5: [-0.38727594736842097, 51.481580421052634],
  TW6: [-0.45348842857142857, 51.470334214285685],
  TW7: [-0.33807536069390476, 51.47001888457515],
  TW8: [-0.3051641903455581, 51.48850979507244],
  TW9: [-0.29462728441821645, 51.465847614568226],
  TW10: [-0.2968195987013646, 51.44785667993054],
  TW11: [-0.32991914658275706, 51.426257474742556],
  TW12: [-0.3680940677966103, 51.424323983050854],
  TW13: [-0.4004365680473374, 51.43945065088756],
  TW14: [-0.4224927941176471, 51.452139338235305],
  TW15: [-0.46034235294117626, 51.43201816176469],
  TW16: [-0.41907755905511834, 51.41256748031496],
  TW17: [-0.44666096000000016, 51.39687960000001],
  TW18: [-0.503528013245033, 51.424698278145684],
  TW19: [-0.5114144705882347, 51.4543105294118],
  TW20: [-0.5477852985074629, 51.42381447761194],
  BN1: [-0.14171230639949448, 50.84129578648143],
  BN2: [-0.08984817619572316, 50.821642838543944],
  BN3: [-0.17432976153931695, 50.83686303921671],
  BN5: [-0.27627836506440895, 50.92765094025278],
  BN6: [-0.14653925925925929, 50.93426748148147],
  BN7: [-0.009977558540933941, 50.88066838172985],
  BN8: [0.04584077338075506, 50.89983557000109],
  BN9: [0.045487080949227335, 50.79933146528484],
  BN10: [0.0027996652388309904, 50.79752891386456],
  BN11: [-0.3822364758928349, 50.816378935750585],
  BN12: [-0.42153683378123036, 50.81753999883305],
  BN13: [-0.41181417475728127, 50.83341529126211],
  BN14: [-0.38470766355140174, 50.83186817757009],
  BN15: [-0.31823656144723106, 50.83847180001132],
  BN16: [-0.4975958568556234, 50.817914229352226],
  BN17: [-0.551273250852385, 50.81358285333297],
  BN18: [-0.5650972871105039, 50.85994956856605],
  BN20: [0.25221071320199195, 50.780586656660034],
  BN21: [0.26911360640074117, 50.774279032180125],
  BN22: [0.27395838780752446, 50.79628026270936],
  BN23: [0.2987337022705396, 50.80316666154459],
  BN24: [0.3140623100714379, 50.82049695932685],
  BN25: [0.13206184697317774, 50.77942013921936],
  BN26: [0.19930817311897664, 50.81654941814961],
  BN27: [0.26244692307692324, 50.87423461538463],
  BN41: [-0.22022212015549072, 50.83870997388713],
  BN42: [-0.23360946891788575, 50.83761736934828],
  BN43: [-0.26963884195425925, 50.83986795561791],
  BN44: [-0.31543615852642215, 50.896238647776514],
  BN45: [-0.1882334210526316, 50.89654578947369],
  DT1: [-2.4417367692307685, 50.71077615384616],
  DT2: [-2.449970382015448, 50.74468260449065],
  DT3: [-2.5028047202778523, 50.635995064095816],
  DT4: [-2.4707492567286975, 50.60708155327357],
  DT5: [-2.443606217974271, 50.547063011999846],
  DT6: [-2.801967137162317, 50.74980185279676],
  DT7: [-2.9621256269760123, 50.726089540084416],
  DT8: [-2.7624772500000003, 50.82341062500003],
  DT9: [-2.517466478873239, 50.93531218309861],
  DT10: [-2.3494882882882884, 50.925158198198204],
  DT11: [-2.1917945454545458, 50.857084715909075],
  IG1: [0.07228281647958364, 51.560131645822786],
  IG2: [0.08116317972350234, 51.57732552995394],
  IG3: [0.10243271844660198, 51.563735436893225],
  IG4: [0.05038852631578949, 51.58073536842106],
  IG5: [0.06402142857142855, 51.58995666666664],
  IG6: [0.08956331967213113, 51.59712303278687],
  IG7: [0.0935829702970297, 51.61395346534657],
  IG8: [0.03476983471074378, 51.60513971074376],
  IG9: [0.04012399999999999, 51.6253403529412],
  IG10: [0.057327590361445795, 51.64723891566264],
  IG11: [0.09417010492282846, 51.53642152185504],
  NE1: [-1.609515054755575, 54.97358107307353],
  NE2: [-1.6090430864197525, 54.986668271604955],
  NE3: [-1.6363668907563031, 55.01061315126049],
  NE4: [-1.6451851402435906, 54.975885355052604],
  NE5: [-1.683911858407079, 54.994896548672564],
  NE6: [-1.5632821492153302, 54.98042027263103],
  NE7: [-1.5822857352941178, 54.999883823529416],
  NE8: [-1.6064319539201972, 54.95324973868287],
  NE9: [-1.5827626162790691, 54.9335971511628],
  NE10: [-1.5609064361683784, 54.95003993898317],
  NE11: [-1.6351900065254938, 54.93925874104086],
  NE12: [-1.5709969629629634, 55.022634296296296],
  NE13: [-1.6655228148148153, 55.03713733333333],
  NE15: [-1.7376199701624848, 54.98696355151192],
  NE16: [-1.699283655815623, 54.93138311340154],
  NE17: [-1.817568780487805, 54.91516],
  NE18: [-1.8633084722222226, 55.03382097222222],
  NE19: [-2.0843662987012985, 55.16094850649346],
  NE20: [-1.8349629192546584, 55.064910434782625],
  NE21: [-1.7190979980408576, 54.96052514436232],
  NE22: [-1.5714799837614053, 55.138918612929935],
  NE23: [-1.5833151785714275, 55.07288517857144],
  NE24: [-1.530720201510633, 55.13228989604112],
  NE25: [-1.4832212637362636, 55.05160571428572],
  NE26: [-1.4665979993635132, 55.06133647694545],
  NE27: [-1.5119251428571419, 55.03493076190475],
  NE28: [-1.518192638159397, 54.997279157591045],
  NE29: [-1.4645844554658427, 55.01262185117915],
  NE30: [-1.4406518020236003, 55.02138558072476],
  NE31: [-1.5099083860572762, 54.97019718249894],
  NE32: [-1.4814318261121295, 54.967261294335415],
  NE33: [-1.427976130339844, 54.98722534145058],
  NE34: [-1.4281732782315677, 54.976115513420545],
  NE35: [-1.4596491139240504, 54.95029569620254],
  NE36: [-1.4480987037037047, 54.942925925925906],
  NE37: [-1.5280037962962962, 54.911904259259245],
  NE38: [-1.5248907384133665, 54.89082800342587],
  NE39: [-1.7643637179487177, 54.92094730769231],
  NE40: [-1.7789743096028394, 54.965134649646735],
  NE41: [-1.8176113636363638, 54.97310886363635],
  NE42: [-1.8612032786885249, 54.960799180327875],
  NE43: [-1.9188082608695651, 54.94974195652174],
  NE44: [-1.9797625, 54.93385461538462],
  NE45: [-2.0076046428571432, 54.983428571428576],
  NE46: [-2.1167153571428576, 54.99323660714284],
  NE47: [-2.2025975722543354, 54.924545202312125],
  NE48: [-2.2563640350877194, 55.13394614035088],
  NE49: [-2.4643870270270267, 54.964582297297305],
  NE61: [-1.7258319017096042, 55.19999270861564],
  NE62: [-1.5885482278481011, 55.1592858227848],
  NE63: [-1.5540622410212128, 55.17905473838382],
  NE64: [-1.5135588267825335, 55.18592986113371],
  NE65: [-1.7395995996776172, 55.31950415345217],
  NE66: [-1.6959585885045763, 55.442193778074234],
  NE67: [-1.6944368029604246, 55.538921334584806],
  NE68: [-1.6408922120179728, 55.61057430184214],
  NE69: [-1.7270150437912173, 55.61004728819502],
  NE70: [-1.8071539174498228, 55.6184677461005],
  NE71: [-2.068255762711865, 55.55254067796611],
  SG1: [-0.18685217391304346, 51.91264333333333],
  SG2: [-0.15358928571428573, 51.90457759740258],
  SG3: [-0.18285904109589038, 51.85947479452054],
  SG4: [-0.25362216783216784, 51.91961524475525],
  SG5: [-0.2903134482758622, 51.97500797413795],
  SG6: [-0.2201938888888889, 51.977712777777796],
  SG7: [-0.17113750000000005, 52.015671532258075],
  SG8: [-0.012029017341040478, 52.07164745664739],
  SG9: [-0.002174388489208621, 51.951412877697834],
  SG10: [0.07980307692307692, 51.84595673076925],
  SG11: [0.024025826771653564, 51.88734622047246],
  SG12: [-0.022532197802197798, 51.82326989010989],
  SG13: [-0.07588811428571426, 51.77936920000001],
  SG14: [-0.10368565217391303, 51.81593987577638],
  SG15: [-0.2634072727272727, 52.012872272727265],
  SG16: [-0.29742276923076905, 52.01586676923076],
  SG17: [-0.34234650000000016, 52.036840166666664],
  SG18: [-0.2797110752688172, 52.08039924731183],
  SG19: [-0.22626967741935483, 52.14263459677421],
  UB1: [-0.3676833862433863, 51.517065555555575],
  UB2: [-0.37547239999999993, 51.499773999999995],
  UB3: [-0.4286521, 51.50551165000001],
  UB4: [-0.40891511520737306, 51.5252196313364],
  UB5: [-0.3748966960352425, 51.542943700440524],
  UB6: [-0.3420986764705882, 51.53778610294113],
  UB7: [-0.4675446043165467, 51.50141057553961],
  UB8: [-0.46604904761904775, 51.53227519480518],
  UB9: [-0.48845068702290073, 51.582948778625976],
  UB10: [-0.45246715789473657, 51.54436731578952],
  UB11: [-0.4451928947368421, 51.51025736842105],
  BR1: [0.022539114754098345, 51.412430557377036],
  BR2: [0.020337225609756104, 51.386867347560994],
  BR3: [-0.030637265624999983, 51.404439804687485],
  BR4: [-0.005626076923076924, 51.375055846153835],
  BR5: [0.09755125984251978, 51.38750374015747],
  BR6: [0.093125234375, 51.3638948828125],
  BR7: [0.06941819672131148, 51.413646448087434],
  BR8: [0.17753249999999995, 51.40210381578946],
  DY1: [-2.0952767063492073, 52.516720992063476],
  DY2: [-2.0826622268907578, 52.4977231932773],
  DY3: [-2.147185084033613, 52.52790953781509],
  DY4: [-2.0555770999999994, 52.53236920000001],
  DY5: [-2.1263273303167423, 52.48202656108598],
  DY6: [-2.162938636363638, 52.495188030303034],
  DY7: [-2.220324213836478, 52.474763899371034],
  DY8: [-2.1561932510288067, 52.45880534979423],
  DY9: [-2.119964723404256, 52.424552553191496],
  DY10: [-2.2090156345177667, 52.38447964467005],
  DY11: [-2.254785147058823, 52.38641950980392],
  DY12: [-2.3464200581395356, 52.38848430232558],
  DY13: [-2.2799646086956518, 52.32407217391305],
  DY14: [-2.453559079754602, 52.376686748466284],
  IP1: [1.1409466996228284, 52.06549810144736],
  IP2: [1.1341953404273433, 52.04622596321336],
  IP3: [1.1855543838598206, 52.04477043053102],
  IP4: [1.182900507784479, 52.05845862285288],
  IP5: [1.2330091869918698, 52.064766829268265],
  IP6: [1.1326857894736846, 52.13106894736839],
  IP7: [0.9308543558282213, 52.07802392638037],
  IP8: [1.0773306842105261, 52.06233563157895],
  IP9: [1.1858810398749833, 51.98194954532285],
  IP10: [1.279689210142181, 52.016273612984385],
  IP11: [1.334863575546835, 51.973456911354454],
  IP12: [1.4176017879897558, 52.081139246578],
  IP13: [1.3200395713782815, 52.1781919306157],
  IP14: [1.061920916030533, 52.201852519084],
  IP15: [1.5843270777672984, 52.14823532308744],
  IP16: [1.573762393227738, 52.20731882274032],
  IP17: [1.5120224864780005, 52.2158112686975],
  IP18: [1.6436333327373531, 52.32846419419686],
  IP19: [1.532732584949992, 52.33336575394945],
  IP20: [1.335842735849057, 52.40546028301887],
  IP21: [1.2206625500000008, 52.36601815000004],
  IP22: [1.0318920121951223, 52.380855670731705],
  IP23: [1.1226012605042017, 52.30264050420169],
  IP24: [0.7990666355140188, 52.43867831775701],
  IP25: [0.8503309482758622, 52.602425862068934],
  IP26: [0.5865363855421686, 52.51391855421686],
  IP27: [0.566774074074074, 52.42620703703701],
  IP28: [0.5558520000000005, 52.31558276470588],
  IP29: [0.6744766233766234, 52.19284493506496],
  IP30: [0.8326974233128833, 52.20564300613498],
  IP31: [0.8190602185792352, 52.29279797814206],
  IP32: [0.7210687200000002, 52.25272655999998],
  IP33: [0.7087115126050417, 52.24242848739497],
  NG1: [-1.1495938815789464, 52.956008486842116],
  NG2: [-1.1363017886178863, 52.93523569105688],
  NG3: [-1.1221795604395595, 52.97433041208789],
  NG4: [-1.0934261497326208, 52.974516791443875],
  NG5: [-1.1486702215189866, 52.99152740506331],
  NG6: [-1.1864914611872144, 52.99758246575342],
  NG7: [-1.1735288167938938, 52.95521259541982],
  NG8: [-1.2071180000000008, 52.96606649999998],
  NG9: [-1.2442569711538456, 52.93161610576923],
  NG10: [-1.2870813571428572, 52.90730635714284],
  NG11: [-1.1769876397515537, 52.897074844720514],
  NG12: [-1.0513070285714288, 52.91554085714285],
  NG13: [-0.8890351785714282, 52.94749866071426],
  NG14: [-1.0286617073170738, 53.013760792682916],
  NG15: [-1.201772125984252, 53.06054141732285],
  NG16: [-1.2911895200000003, 53.02728468],
  NG17: [-1.2619594776119403, 53.111586119402986],
  NG18: [-1.192495701357466, 53.14054167420815],
  NG19: [-1.2023623308270686, 53.155899436090216],
  NG20: [-1.1836456179775274, 53.21343584269662],
  NG21: [-1.1140861417322836, 53.13287031496063],
  NG22: [-0.928116001509232, 53.19414692394434],
  NG23: [-0.7987575274754031, 53.132647338934035],
  NG24: [-0.7880627058823529, 53.070679294117646],
  NG25: [-0.9790921600000001, 53.07060920000001],
  NG31: [-0.6414139682539686, 52.9160338095238],
  NG32: [-0.660336864864865, 52.940492000000006],
  NG33: [-0.5734180327868854, 52.81655426229509],
  NG34: [-0.39302789473684197, 52.96564781954886],
  NG90: [-1.1913732142857143, 52.92548750000001],
  SK1: [-2.147867551020409, 53.406031700680266],
  SK2: [-2.1383631527093594, 53.39469921182268],
  SK3: [-2.1708993532338297, 53.39634029850746],
  SK4: [-2.1819564912280702, 53.4220177631579],
  SK5: [-2.154022325581396, 53.43408453488375],
  SK6: [-2.0760909042553184, 53.40099968085103],
  SK7: [-2.1493577990430612, 53.36774392344495],
  SK8: [-2.206453861788618, 53.378590040650415],
  SK9: [-2.244089923664121, 53.325255648854956],
  SK10: [-2.141731283783785, 53.27956003378378],
  SK11: [-2.1591183900928783, 53.24218727554182],
  SK12: [-2.08173107913669, 53.35252460431652],
  SK13: [-1.968462021276595, 53.45268329787233],
  SK14: [-2.048644101123595, 53.45539415730339],
  SK15: [-2.049782127659575, 53.48706425531917],
  SK16: [-2.07900344370861, 53.4739044370861],
  SK17: [-1.8458559558823522, 53.21158749999998],
  SK22: [-1.9947432222222223, 53.376638333333325],
  SK23: [-1.953789411764706, 53.33073485294119],
  W1B: [-0.14188729729729738, 51.51586721621625],
  W1C: [-0.14933045226130662, 51.51439286432161],
  W1D: [-0.13364390070921983, 51.5136224468085],
  W1F: [-0.13640517094017096, 51.513301709401716],
  W1G: [-0.1475608076923077, 51.518602769230746],
  W1H: [-0.15982170731707301, 51.51747107317073],
  W1J: [-0.14323265129683002, 51.50845786743517],
  W1K: [-0.14940267716535444, 51.51075393700788],
  W1S: [-0.14221116197183098, 51.5109721830986],
  W1T: [-0.13734216216216222, 51.52035396396399],
  W1U: [-0.15231589403973497, 51.51815043046356],
  W1W: [-0.14158232673267332, 51.51965237623759],
  W2: [-0.18197713178294575, 51.51685267441864],
  W3: [-0.2676693893129771, 51.51060156488543],
  W4: [-0.2614947375999983, 51.49269409588126],
  W5: [-0.3013112043795621, 51.51287806569342],
  W6: [-0.22559437725417236, 51.492835611135746],
  W7: [-0.3335096296296296, 51.512080864197564],
  W8: [-0.19446280000000005, 51.50033419999997],
  W9: [-0.19310525862068964, 51.52807409482757],
  W10: [-0.21350499999999997, 51.52331999999999],
  W11: [-0.20516533039647578, 51.51186136563877],
  W12: [-0.23702854545454544, 51.506545818181834],
  W13: [-0.32184511848341224, 51.51361175355451],
  W14: [-0.21012133027522936, 51.49509417431193],
  BS1: [-2.596664642039387, 51.45372972984753],
  BS2: [-2.582879468318424, 51.45890219619707],
  BS3: [-2.6003826732104667, 51.43788581690181],
  BS4: [-2.5654297825048356, 51.437021340427734],
  BS5: [-2.547103359073359, 51.46161652509654],
  BS6: [-2.597383946587536, 51.47143175074186],
  BS7: [-2.5844027450980396, 51.48474552941176],
  BS8: [-2.6324803938393324, 51.457931410182766],
  BS9: [-2.6224373076337737, 51.48607601911452],
  BS10: [-2.613739556334733, 51.50712879641735],
  BS11: [-2.681169342187882, 51.50202693332981],
  BS13: [-2.608288145161291, 51.41480145161292],
  BS14: [-2.5664079166666647, 51.41362729166665],
  BS15: [-2.5104795390070933, 51.46030893617019],
  BS16: [-2.5130190235690235, 51.48687016835014],
  BS20: [-2.730041939754989, 51.47890493849894],
  BS21: [-2.845195184155633, 51.426553445134665],
  BS22: [-2.9331788249794655, 51.370789347106644],
  BS23: [-2.9746296986460017, 51.334913099904796],
  BS24: [-2.9189189302325556, 51.33175227906973],
  BS25: [-2.8263964935064934, 51.31997558441559],
  BS26: [-2.8674161702127656, 51.2821445744681],
  BS27: [-2.767656041666667, 51.26545145833333],
  BS28: [-2.812349508196723, 51.22448393442623],
  BS29: [-2.8774908928571428, 51.33471714285714],
  BS30: [-2.4606817647058823, 51.448515546218516],
  BS31: [-2.492656500000001, 51.40551650000002],
  BS32: [-2.5608642783505147, 51.545121546391705],
  BS34: [-2.563339315068493, 51.520996757990844],
  BS35: [-2.57465019956572, 51.594656258728534],
  BS36: [-2.4882084536082467, 51.52071886597939],
  BS37: [-2.4088641904761907, 51.5391242857143],
  BS39: [-2.5350067105263165, 51.33833171052631],
  BS40: [-2.692192874251498, 51.34482916167667],
  BS41: [-2.6385702654867256, 51.414956017699126],
  BS48: [-2.7273027419354827, 51.421384193548406],
  BS49: [-2.8080315277777776, 51.37817819444447],
  E1: [-0.061196734104046226, 51.51856994219656],
  E1W: [-0.05662153777719857, 51.50952804145973],
  E2: [-0.06319355263157894, 51.529544210526296],
  E3: [-0.023488035826489003, 51.526417413281884],
  E4: [-0.00499012195121951, 51.625135365853666],
  E5: [-0.056287639484978565, 51.55989819742489],
  E6: [0.052421970300470494, 51.52879318235049],
  E7: [0.02837411428571428, 51.545987085714295],
  E8: [-0.0662049387755102, 51.54447795918367],
  E9: [-0.04388484042553191, 51.54411978723401],
  E10: [-0.013461004784689, 51.56897449760768],
  E11: [0.012129606299212593, 51.56871559055114],
  E12: [0.05059200000000001, 51.551462068965506],
  E13: [0.025444010416666687, 51.527165781249984],
  E14: [-0.017417322673868176, 51.511581159669824],
  E15: [0.00380186996163654, 51.54129079309132],
  E16: [0.02787218546692572, 51.514260126423274],
  E17: [-0.018909497206703912, 51.586203631284924],
  E18: [0.02522731343283582, 51.59272395522388],
  E20: [-0.008586, 51.545272],
  IV1: [-4.243828740583561, 57.498512392946495],
  IV2: [-4.133587152077544, 57.493295818259305],
  IV3: [-4.294086426478852, 57.4660234313724],
  IV4: [-4.533002878960662, 57.457024093342454],
  IV5: [-4.404804966729446, 57.46997040266902],
  IV6: [-4.472378474268686, 57.52423017623011],
  IV7: [-4.319151090564328, 57.612159814863524],
  IV8: [-4.257541772927852, 57.55485661903991],
  IV9: [-4.199168700145518, 57.55995828020617],
  IV10: [-4.1269904988993025, 57.593795248281786],
  IV11: [-4.037803561374003, 57.66090279489426],
  IV12: [-3.8303087068909503, 57.58669978592963],
  IV13: [-4.072698064516129, 57.31443516129032],
  IV14: [-4.595124285714285, 57.58918971428571],
  IV15: [-4.418086154278227, 57.60344757712233],
  IV16: [-4.321195655314781, 57.66370155522653],
  IV17: [-4.2718303352806055, 57.695753581295804],
  IV18: [-4.117269287043731, 57.720162026868486],
  IV19: [-4.0708625173624515, 57.7818769673072],
  IV20: [-3.879585690435891, 57.82564065231337],
  IV21: [-5.769002506029778, 57.7382689120372],
  IV22: [-5.605091956328119, 57.79327267879659],
  IV23: [-5.227230874024074, 57.8632572894823],
  IV24: [-4.364332028102855, 57.89234448013626],
  IV25: [-4.0836084834140856, 57.88602047649311],
  IV26: [-5.369497083077076, 58.012414085379575],
  IV27: [-4.992266794515877, 58.37448269352922],
  IV28: [-4.178015833333332, 58.0358575],
  IV30: [-3.3992127339780547, 57.683229487687626],
  IV31: [-3.298955582088648, 57.715235489094034],
  IV32: [-3.10671923171121, 57.648887374561276],
  IV36: [-3.6379435413245593, 57.63329992770738],
  IV40: [-5.748216892487316, 57.29722136022255],
  IV41: [-5.7341949207830325, 57.27294862659331],
  IV42: [-5.783758652892166, 57.24600667907686],
  IV43: [-5.8050938349363435, 57.15620416904208],
  IV44: [-5.9136926027006576, 57.13009427432877],
  IV45: [-5.9755718884485525, 57.04069982635922],
  IV46: [-6.00176487340242, 57.09371692528455],
  IV47: [-6.369270861350729, 57.25365207258817],
  IV48: [-6.111090167042725, 57.31071295820376],
  IV49: [-6.014126892319729, 57.21009471566843],
  IV51: [-6.205135699687204, 57.54178947816441],
  IV52: [-5.666978530584673, 57.34299036080319],
  IV53: [-5.544214612528284, 57.349173713455436],
  IV54: [-5.696565237424614, 57.447989877483685],
  IV55: [-6.61410824749807, 57.4515581212783],
  IV56: [-6.457549220364421, 57.354920906497135],
  IV63: [-4.687967499999999, 57.25937516666665],
  NN1: [-0.8835702054794519, 52.24275273972602],
  NN2: [-0.8951088489208631, 52.26299748201438],
  NN3: [-0.8459904117647061, 52.263913352941145],
  NN4: [-0.8933213953488377, 52.21580333333332],
  NN5: [-0.9307220002538449, 52.24639475599403],
  NN6: [-0.9157542801556421, 52.32535299610896],
  NN7: [-0.9083655371900827, 52.213373057851236],
  NN8: [-0.6896284090909092, 52.30644863636365],
  NN9: [-0.6240682035928143, 52.331314970059864],
  NN10: [-0.594510705882353, 52.291387764705874],
  NN11: [-1.1935889221556881, 52.22648479041917],
  NN12: [-0.9940222656250003, 52.12281140625],
  NN13: [-1.1537528000000004, 52.036447199999984],
  NN14: [-0.7012409587811541, 52.39977659279121],
  NN15: [-0.7111514864864863, 52.38572121621623],
  NN16: [-0.7230332558139533, 52.40408007751939],
  NN17: [-0.670223803072583, 52.50934299466126],
  NN18: [-0.7044931782945739, 52.482861007751964],
  NN29: [-0.6607795604395604, 52.25835560439562],
  SL0: [-0.5164647999999998, 51.527885899999994],
  SL1: [-0.6277149056603774, 51.525080943396205],
  SL2: [-0.6008889684813757, 51.53173859598847],
  SL3: [-0.5588429259259258, 51.51716159259256],
  SL4: [-0.6349397765363126, 51.46807374301673],
  SL5: [-0.6702507563025211, 51.407592268907564],
  SL6: [-0.7254468421052629, 51.524354605263184],
  SL7: [-0.7910132432432436, 51.57743252252253],
  SL8: [-0.7065939682539687, 51.57790238095238],
  SL9: [-0.5543999999999998, 51.59336357142856],
  WA1: [-2.573981667480741, 53.39248239187712],
  WA2: [-2.5815851010101003, 53.41091282828285],
  WA3: [-2.5324646396396395, 53.449620360360356],
  WA4: [-2.5926354415548643, 53.35767662767175],
  WA5: [-2.638977415111244, 53.40216789605247],
  WA6: [-2.716558542106834, 53.26318299370893],
  WA7: [-2.6914415281290607, 53.330977981894776],
  WA8: [-2.74242097362428, 53.370514636915644],
  WA9: [-2.722532746113989, 53.4396580310881],
  WA10: [-2.759041744966445, 53.45437993288592],
  WA11: [-2.730238318181818, 53.479713181818205],
  WA12: [-2.631152978723405, 53.459858617021276],
  WA13: [-2.4544290163934437, 53.38429549180326],
  WA14: [-2.3662002916666673, 53.384928875000014],
  WA15: [-2.3226305158730165, 53.383951706349194],
  WA16: [-2.3810541422594143, 53.30211301255226],
  CA1: [-2.916636260162602, 54.887476585365874],
  CA2: [-2.9417210317460327, 54.880351190476176],
  CA3: [-2.937621544117648, 54.90624963235296],
  CA4: [-2.83564832460733, 54.845727696335075],
  CA5: [-3.0418414389008084, 54.894734847718986],
  CA6: [-2.937707475848549, 54.97522307712679],
  CA7: [-3.2579639026300895, 54.879794810613134],
  CA8: [-2.6548018543046368, 54.93242152317883],
  CA9: [-2.4160982926829266, 54.78959317073171],
  CA10: [-2.6759097596153847, 54.62611644230769],
  CA11: [-2.8294303278688524, 54.660806994535506],
  CA12: [-3.136798771929824, 54.60299719298245],
  CA13: [-3.345288095238095, 54.64962095238095],
  CA14: [-3.5193338026646734, 54.62602012529901],
  CA15: [-3.462047024549596, 54.730780143766914],
  CA16: [-2.4825275714285704, 54.577065714285716],
  CA17: [-2.347055660377358, 54.47776264150942],
  CA18: [-3.38940786036278, 54.35573080983994],
  CA19: [-3.411745722136504, 54.372975772946845],
  CA20: [-3.4308565335909855, 54.42527578141522],
  CA21: [-3.521887045670654, 54.44553812668183],
  CA22: [-3.527050492112996, 54.47719008683464],
  CA23: [-3.469777702702702, 54.51746486486486],
  CA24: [-3.5486581818181815, 54.515011515151514],
  CA25: [-3.5136947222222226, 54.523778472222254],
  CA26: [-3.4730834782608695, 54.54501152173914],
  CA27: [-3.5957471757386306, 54.48937530758417],
  CA28: [-3.581020479935522, 54.54532610634576],
  EC1A: [-0.0995973863636364, 51.518787159090905],
  EC1M: [-0.10211149122807013, 51.52163280701755],
  EC1N: [-0.10937729166666667, 51.520085520833334],
  EC1R: [-0.10864338983050849, 51.525251242937834],
  EC1V: [-0.09570833935018042, 51.52664815884477],
  EC1Y: [-0.09189188976377947, 51.52316086614173],
  EC2A: [-0.08299195652173914, 51.522870869565196],
  EC2M: [-0.08207870370370372, 51.51809638888887],
  EC2N: [-0.08405827586206895, 51.51540155172413],
  EC2R: [-0.08855681159420292, 51.51506913043477],
  EC2V: [-0.09363349206349207, 51.51545698412698],
  EC2Y: [-0.09314051948051943, 51.519528831168834],
  EC3A: [-0.0793498039215686, 51.514795098039215],
  EC3M: [-0.08237086206896552, 51.51155275862069],
  EC3N: [-0.07588369129276529, 51.511075544144845],
  EC3R: [-0.08177159493631835, 51.51018902737912],
  EC3V: [-0.08572089285714288, 51.5125310714286],
  EC4A: [-0.10833945054945056, 51.51538868131866],
  EC4M: [-0.09906313953488372, 51.51399744186048],
  EC4N: [-0.0897837878787879, 51.51199560606063],
  EC4R: [-0.08996431488139685, 51.51098321830685],
  EC4V: [-0.09960132444191191, 51.51247425714125],
  EC4Y: [-0.10841483006867292, 51.513192481574265],
  KA1: [-4.495819735449734, 55.59196592592595],
  KA2: [-4.562882475247522, 55.59865683168317],
  KA3: [-4.489137872340428, 55.64307691489361],
  KA4: [-4.37929, 55.59821982456142],
  KA5: [-4.412459238095238, 55.50561895238096],
  KA6: [-4.540548875000001, 55.42722362499999],
  KA7: [-4.669435509644399, 55.43092307104604],
  KA8: [-4.613047695890405, 55.47314798530691],
  KA9: [-4.6006861360116975, 55.501612450076],
  KA10: [-4.665191353806301, 55.546789203537806],
  KA11: [-4.634519553022253, 55.613487704075155],
  KA12: [-4.6789601787744095, 55.61747564636633],
  KA13: [-4.6792131038081095, 55.66401733612734],
  KA14: [-4.671878148148148, 55.73982185185186],
  KA15: [-4.607657142857143, 55.745050634920624],
  KA16: [-4.32978864864865, 55.610605135135145],
  KA17: [-4.259082, 55.610282571428584],
  KA18: [-4.240394390243902, 55.46720939024389],
  KA19: [-4.679708901515828, 55.33749204935628],
  KA20: [-4.7409721065022365, 55.63802776107316],
  KA21: [-4.779868894034164, 55.64672203179084],
  KA22: [-4.8189124492533075, 55.65164255695989],
  KA23: [-4.8902655405209705, 55.71107822386305],
  KA24: [-4.721062625, 55.727712999999994],
  KA25: [-4.691796341463415, 55.758673658536594],
  KA26: [-4.927799338851332, 55.16913881205167],
  KA27: [-5.207697842087986, 55.56434569407151],
  KA28: [-4.927570264467708, 55.75469585174903],
  KA29: [-4.859016289117413, 55.75284836931135],
  KA30: [-4.85981774209648, 55.80542167185443],
  NP4: [-3.029347642276422, 51.72495666666669],
  NP7: [-2.976453465346534, 51.83904905940593],
  NP8: [-3.1698500000000003, 51.861868125],
  NP10: [-3.050838002965157, 51.57111765184603],
  NP11: [-3.1411443312101905, 51.64920305732481],
  NP12: [-3.198509608938548, 51.67685759776533],
  NP13: [-3.149301428571429, 51.73852163265304],
  NP15: [-2.887521080274271, 51.713190665574785],
  NP16: [-2.685534955065834, 51.66786308729354],
  NP18: [-2.9350622120012484, 51.59847715455226],
  NP19: [-2.962053851231332, 51.58728273564985],
  NP20: [-3.001025081152556, 51.58063734883227],
  NP22: [-3.2578374000000014, 51.76587219999998],
  NP23: [-3.1924568067226886, 51.77298798319326],
  NP24: [-3.241172444444445, 51.71915133333333],
  NP25: [-2.7255385313764613, 51.77709932519212],
  NP26: [-2.787245234470897, 51.59074809752919],
  NP44: [-3.025268850574712, 51.64638517241381],
  SM1: [-0.1918513658536585, 51.36833331707321],
  SM2: [-0.200673550295858, 51.350792781065145],
  SM3: [-0.21654137566137577, 51.37211074074074],
  SM4: [-0.20084106557377052, 51.39120942622948],
  SM5: [-0.17015708463949855, 51.368368181818234],
  SM6: [-0.14405338095238104, 51.36253119047623],
  SM7: [-0.19822355371900824, 51.32343297520661],
  WC1A: [-0.12592633663366337, 51.51760029702968],
  WC1B: [-0.12646242424242427, 51.51938339393942],
  WC1E: [-0.13245766355140187, 51.52176018691589],
  WC1H: [-0.12633333333333338, 51.52621351515152],
  WC1N: [-0.12060760736196317, 51.52321723926383],
  WC1R: [-0.11545329896907218, 51.51957113402061],
  WC1V: [-0.11765928000000002, 51.51778520000001],
  WC1X: [-0.1150151178451179, 51.52442316498317],
  WC2A: [-0.11441158536585368, 51.51608487804879],
  WC2B: [-0.12026959677419354, 51.51430475806454],
  WC2E: [-0.12301514492753625, 51.5123036231884],
  WC2H: [-0.12830900523560212, 51.512804502617776],
  WC2N: [-0.12578019360660253, 51.50947655689641],
  WC2R: [-0.11801983179018888, 51.511461447262114],
  CB1: [0.14493614349775788, 52.196474573991],
  CB2: [0.1267670707070707, 52.19167636363639],
  CB3: [0.10058054054054051, 52.212511824324324],
  CB4: [0.1269600684931507, 52.22074089041096],
  CB5: [0.14275260869565215, 52.21186627329193],
  CB6: [0.22961842222552106, 52.411685356734075],
  CB7: [0.32408031390134545, 52.38094802690582],
  CB8: [0.4495196598639457, 52.21417285714289],
  CB9: [0.4532490361445784, 52.08611433734942],
  CB10: [0.272606062176166, 52.02912948186531],
  CB11: [0.21087411428571415, 52.00123862857142],
  CB21: [0.2845381159420289, 52.13182108695655],
  CB22: [0.12171969230769233, 52.12724053846156],
  CB23: [-0.020306376811594192, 52.21187956521737],
  CB24: [0.07804822561482419, 52.2736011370041],
  CB25: [0.23845333333333332, 52.260688958333326],
  EH1: [-3.1936874407582923, 55.951434739336484],
  EH2: [-3.2019421238938066, 55.952361769911484],
  EH3: [-3.2059846857142857, 55.95259608571427],
  EH4: [-3.2617962036675197, 55.96298036355869],
  EH5: [-3.2248322034162578, 55.976869538402404],
  EH6: [-3.1773286791112354, 55.96991272122985],
  EH7: [-3.168931516617248, 55.96143238317348],
  EH8: [-3.165469961389963, 55.94866818532819],
  EH9: [-3.18305890052356, 55.93303973821995],
  EH10: [-3.2133997154471556, 55.92165329268289],
  EH11: [-3.251974318936879, 55.932227009966745],
  EH12: [-3.275759479166668, 55.94458034722221],
  EH13: [-3.2424231707317075, 55.90667227642277],
  EH14: [-3.273598525896414, 55.9153462948207],
  EH15: [-3.1217512602873367, 55.944938376941685],
  EH16: [-3.1560045583038883, 55.922771554770314],
  EH17: [-3.1498941666666664, 55.90475886363637],
  EH18: [-3.121490491803277, 55.87656303278687],
  EH19: [-3.10312179245283, 55.8720741509434],
  EH20: [-3.156629056603773, 55.87888132075472],
  EH21: [-3.0471454718364264, 55.93488596245409],
  EH22: [-3.0610307194244615, 55.891959784172684],
  EH23: [-3.0567369411764704, 55.82775035294118],
  EH24: [-3.134996216216216, 55.84675189189189],
  EH25: [-3.178922112676057, 55.85769971830986],
  EH26: [-3.223885974025972, 55.82860987012987],
  EH27: [-3.412402156862745, 55.88522588235293],
  EH28: [-3.3790199999999992, 55.929939622641484],
  EH29: [-3.3944753658536584, 55.95810780487805],
  EH30: [-3.3941367778590146, 55.98782409174624],
  EH31: [-2.8444148968832, 56.03702131186379],
  EH32: [-2.9168070814150435, 55.98210770486147],
  EH33: [-2.9415109090909097, 55.94556779220779],
  EH34: [-2.867719230769231, 55.91058820512819],
  EH35: [-2.934275714285714, 55.902354761904746],
  EH36: [-2.8498582608695653, 55.85377956521739],
  EH37: [-2.9528983928571426, 55.84938089285715],
  EH38: [-2.9553860000000007, 55.770842],
  EH39: [-2.722671293469306, 56.05175333491319],
  EH40: [-2.6700058620689657, 55.999887241379305],
  EH41: [-2.7592496923076926, 55.936792615384626],
  EH42: [-2.5516674312421226, 55.99970145267665],
  EH43: [-3.0011290909090915, 55.625709090909076],
  EH44: [-3.080397647058824, 55.630261764705864],
  EH45: [-3.1949007407407413, 55.65544092592591],
  EH46: [-3.336797608695651, 55.743940652173904],
  EH47: [-3.646799310344827, 55.85917801724135],
  EH48: [-3.6714282568807355, 55.89721816513762],
  EH49: [-3.57125296315843, 55.98541346070918],
  EH51: [-3.6060977367741063, 56.00956350614722],
  EH52: [-3.4958811340206184, 55.93471257731959],
  EH53: [-3.478305909090911, 55.89501490909092],
  EH54: [-3.5166693243243254, 55.89372932432432],
  EH55: [-3.587458645833335, 55.83333135416667],
  KT1: [-0.2969894811320756, 51.40815301886791],
  KT2: [-0.28923628318584077, 51.41924969026549],
  KT3: [-0.25659348837209295, 51.399705581395345],
  KT4: [-0.24393411428571418, 51.376309542857165],
  KT5: [-0.2876199999999999, 51.39017652941178],
  KT6: [-0.301099898989899, 51.38627560606065],
  KT7: [-0.33614975999999996, 51.38687887999998],
  KT8: [-0.35527100000000006, 51.40072239999998],
  KT9: [-0.30370504201680676, 51.362392521008395],
  KT10: [-0.3532119496855347, 51.37023773584906],
  KT11: [-0.40530914062499984, 51.32387773437499],
  KT12: [-0.4105891304347824, 51.37799850931676],
  KT13: [-0.45034490445859865, 51.36539197452229],
  KT14: [-0.49235105263157886, 51.339068120300745],
  KT15: [-0.49816881481481445, 51.35915629629629],
  KT16: [-0.520727658227848, 51.383559873417695],
  KT17: [-0.24705926724137917, 51.34037801724136],
  KT18: [-0.2615505932203389, 51.3131326694915],
  KT19: [-0.26770313901345283, 51.35189071748877],
  KT20: [-0.23965397790055248, 51.28013513812147],
  KT21: [-0.3027740506329115, 51.31042531645571],
  KT22: [-0.3444482233502539, 51.30403857868016],
  KT23: [-0.37705932773109246, 51.2779037815126],
  KT24: [-0.41954353535353534, 51.27069585858583],
  NR1: [1.3048118005314433, 52.62445970475084],
  NR2: [1.2818548558054137, 52.627875841454106],
  NR3: [1.29007334796617, 52.64254948704073],
  NR4: [1.2553512834224594, 52.61696604278077],
  NR5: [1.2314189171974523, 52.63969394904456],
  NR6: [1.2774489071038249, 52.656044863388004],
  NR7: [1.3341392748195073, 52.63970533525615],
  NR8: [1.205315764705882, 52.67368070588236],
  NR9: [1.0844169811320754, 52.64206166037736],
  NR10: [1.2469708294930872, 52.740539308755764],
  NR11: [1.2632262024915764, 52.84991490964244],
  NR12: [1.4676315192050453, 52.72993799015881],
  NR13: [1.499865337280822, 52.62357186598689],
  NR14: [1.425735884548241, 52.56971944225695],
  NR15: [1.2892907441860462, 52.50746804651163],
  NR16: [1.0664160591133007, 52.47806527093596],
  NR17: [0.9733113793103446, 52.513559396551706],
  NR18: [1.1038574590163932, 52.567560327868826],
  NR19: [0.9187867808219179, 52.675290410958915],
  NR20: [0.9864035775862072, 52.73387142241381],
  NR21: [0.8543335937500003, 52.85028619791663],
  NR22: [0.8552677777777778, 52.89216488888887],
  NR23: [0.888548187280992, 52.96177755224171],
  NR24: [1.04839010989011, 52.861440659340666],
  NR25: [1.019476461364503, 52.95565784926361],
  NR26: [1.1964882666851067, 52.929894594183565],
  NR27: [1.2942629303455535, 52.91415372936343],
  NR28: [1.4127636129032255, 52.820246000000004],
  NR29: [1.5821589814316488, 52.68694428949516],
  NR30: [1.6971074296461073, 52.61312990330217],
  NR31: [1.6633941136164676, 52.56686262994519],
  NR32: [1.6979477688621503, 52.49401294767208],
  NR33: [1.7105245420090989, 52.45977445112726],
  NR34: [1.5939018260199118, 52.4529584140411],
  NR35: [1.4311953500072505, 52.460057957913584],
  SN1: [-1.7822119186046503, 51.557403023255794],
  SN2: [-1.7914410135135135, 51.58179260135133],
  SN3: [-1.752050769230769, 51.56595171597632],
  SN4: [-1.8160549132947978, 51.52800173410406],
  SN5: [-1.8480553030303026, 51.57284159090909],
  SN6: [-1.7712742857142851, 51.631301098901105],
  SN7: [-1.5634554310344826, 51.651956637931],
  SN8: [-1.6833843925233634, 51.38213532710281],
  SN9: [-1.796911290322581, 51.32638354838712],
  SN10: [-1.9868787000000006, 51.33871519999998],
  SN11: [-1.9942621818181827, 51.44564572727271],
  SN12: [-2.14827081081081, 51.37254513513513],
  SN13: [-2.2188199074074078, 51.41847796296297],
  SN14: [-2.208879595588236, 51.479416764705896],
  SN15: [-2.0678454723127047, 51.469708957654724],
  SN16: [-2.0848339316239315, 51.596426923076926],
  SN25: [-1.7962958008658023, 51.59288532467531],
  SN26: [-1.7980652272727276, 51.61515068181818],
  WD3: [-0.47431731343283573, 51.646168656716426],
  WD4: [-0.4559937878787878, 51.706782196969705],
  WD5: [-0.41363191919191916, 51.70676636363636],
  WD6: [-0.2840812380952381, 51.65729866666666],
  WD7: [-0.30480413043478277, 51.68737173913044],
  WD17: [-0.4030322448979592, 51.662828469387804],
  WD18: [-0.41172493670886073, 51.64979221518988],
  WD19: [-0.39002983471074376, 51.63466975206612],
  WD23: [-0.3631114685314687, 51.64861160839161],
  WD24: [-0.4004549390243903, 51.67501835365851],
  WD25: [-0.37898729857819924, 51.6832639810427],
  CF3: [-3.1031117468356633, 51.51432944369815],
  CF5: [-3.246964270835093, 51.48425602536315],
  CF10: [-3.171135551752113, 51.47348091089314],
  CF11: [-3.197093752982958, 51.47000389401627],
  CF14: [-3.199676273584906, 51.51726915094338],
  CF15: [-3.268435454545453, 51.535927972027956],
  CF23: [-3.1562381690127066, 51.51136578316324],
  CF24: [-3.1566274176856775, 51.49053290674348],
  CF31: [-3.5702163513513505, 51.51031054054051],
  CF32: [-3.5975350691192878, 51.52089230508606],
  CF33: [-3.695530221229542, 51.52844213877882],
  CF34: [-3.6513117857142845, 51.60955357142858],
  CF35: [-3.5375594634146372, 51.52101882926828],
  CF36: [-3.70873005432997, 51.48698028693161],
  CF37: [-3.334515230769233, 51.603988153846124],
  CF38: [-3.328541911764706, 51.56263544117646],
  CF39: [-3.4367009803921573, 51.602695882352926],
  CF40: [-3.455535113636364, 51.61923693181818],
  CF41: [-3.4781747826086957, 51.64728434782608],
  CF42: [-3.5211082692307687, 51.6652630769231],
  CF43: [-3.453574666666667, 51.65563280000001],
  CF44: [-3.4906948076923094, 51.735082596153816],
  CF45: [-3.363038842105265, 51.6713865263158],
  CF46: [-3.304247721518986, 51.672371898734184],
  CF47: [-3.376720854700854, 51.75277273504275],
  CF48: [-3.371240334928229, 51.745852822966505],
  CF61: [-3.493211337458502, 51.40555183288419],
  CF62: [-3.3189821255453817, 51.40371121198334],
  CF63: [-3.2602538106721246, 51.410742882334],
  CF64: [-3.201457683038524, 51.427275600597824],
  CF71: [-3.4523532976841795, 51.46212996121925],
  CF72: [-3.3866839795918375, 51.53040091836734],
  CF81: [-3.254795045045045, 51.71001153153154],
  CF82: [-3.234213960396039, 51.65126594059407],
  CF83: [-3.21423214953271, 51.58918560747665],
  EN1: [-0.06630185567010308, 51.65603144329894],
  EN2: [-0.0924938135593221, 51.65995542372881],
  EN3: [-0.03963119999999999, 51.65938794285714],
  EN4: [-0.16139237373737375, 51.64827924242422],
  EN5: [-0.19840995098039207, 51.65118303921571],
  EN6: [-0.17685744, 51.702443520000024],
  EN7: [-0.06499347826086954, 51.70646269565216],
  EN8: [-0.0369034730538922, 51.699780898203585],
  EN9: [0.017133439999999993, 51.70704864000003],
  EN10: [-0.029359417475728147, 51.738584466019425],
  EN11: [-0.01427194444444445, 51.76426027777775],
  KW1: [-3.0964438776346714, 58.52674794343044],
  KW2: [-3.158674486121034, 58.34701419776506],
  KW3: [-3.2487594558048523, 58.3075701716009],
  KW5: [-3.3661394269619196, 58.28359131906907],
  KW6: [-3.447124033393117, 58.242721978835554],
  KW7: [-3.5101158642535997, 58.1790394431742],
  KW8: [-3.676273873413341, 58.10870866077796],
  KW9: [-3.868121515854404, 58.02563336318189],
  KW10: [-4.003576838238247, 57.95166188940857],
  KW11: [-4.132412272727273, 58.27782909090909],
  KW12: [-3.4939885294117654, 58.478713235294116],
  KW13: [-3.9276933333333335, 58.44734416666666],
  KW14: [-3.892666308475623, 58.57816273649203],
  KW15: [-2.9735123861820987, 58.98603739458869],
  KW16: [-3.270467808229892, 58.891778222807446],
  KW17: [-2.848905498888753, 59.1039119048257],
  NW1: [-0.14779108225108234, 51.531435173160176],
  NW2: [-0.22055414578587676, 51.556649954441944],
  NW3: [-0.1733781290322581, 51.55262409677416],
  NW4: [-0.22385312138728325, 51.587510578034696],
  NW5: [-0.1448417543859649, 51.5527240350877],
  NW6: [-0.19690584158415847, 51.542049628712824],
  NW7: [-0.24076474178403742, 51.615750046948364],
  NW8: [-0.17540244813278003, 51.53186589211622],
  NW9: [-0.2573501149425287, 51.58587475095787],
  NW10: [-0.2483422117647061, 51.543899764705934],
  NW11: [-0.19920155737704934, 51.57485204918031],
  SO14: [-1.398101531539379, 50.90811857035573],
  SO15: [-1.4305428992884102, 50.9191997308697],
  SO16: [-1.4413066270680663, 50.93232879090767],
  SO17: [-1.395890782793459, 50.92521555165212],
  SO18: [-1.3573418793935184, 50.92438276028008],
  SO19: [-1.352506423651693, 50.90672516611646],
  SO20: [-1.5026565486725665, 51.12284522123893],
  SO21: [-1.3178308965517236, 51.071189517241386],
  SO22: [-1.3342269918699186, 51.066360487804886],
  SO23: [-1.3124437762237766, 51.07011013986015],
  SO24: [-1.1294991818181817, 51.09757372727272],
  SO30: [-1.2934266085800759, 50.91521928812967],
  SO31: [-1.2953127224371435, 50.87595328565437],
  SO32: [-1.2058902777777778, 50.94807868055554],
  SO40: [-1.4795558918695189, 50.90962891922861],
  SO41: [-1.5479700456893035, 50.750213474530405],
  SO42: [-1.4364251292222412, 50.79927475613098],
  SO43: [-1.6064551724137932, 50.91090310344826],
  SO45: [-1.3619707053365218, 50.82779690700339],
  SO50: [-1.341077254901961, 50.97584535947712],
  SO51: [-1.5129266666666663, 50.998221200000025],
  SO52: [-1.436974, 50.978957600000015],
  SO53: [-1.3806546363636367, 50.98525063636366],
  WF1: [-1.4882230901287554, 53.68870085836909],
  WF2: [-1.512484555160143, 53.67501644128115],
  WF3: [-1.518287109374999, 53.72438683593751],
  WF4: [-1.5054065634674931, 53.64278727554183],
  WF5: [-1.5711237894736847, 53.68285800000003],
  WF6: [-1.4151253535353534, 53.70281828282826],
  WF7: [-1.361571397058824, 53.67207169117646],
  WF8: [-1.2805442307692307, 53.671295538461536],
  WF9: [-1.329939908256881, 53.61616311926604],
  WF10: [-1.358049797297297, 53.72909344594592],
  WF11: [-1.2480560833333334, 53.72067816666668],
  WF12: [-1.619199831932774, 53.68861214285709],
  WF13: [-1.6474595566502466, 53.69405339901473],
  WF14: [-1.697686186440678, 53.67833855932205],
  WF15: [-1.702458999999999, 53.708369999999995],
  WF16: [-1.6687868548387097, 53.71085959677418],
  WF17: [-1.6411687793427223, 53.71482727699531],
  CH1: [-2.91887360220941, 53.214195131471],
  CH2: [-2.868387294348196, 53.225874115320224],
  CH3: [-2.8148224041811836, 53.15693174216027],
  CH4: [-2.9449584865800382, 53.16460393255492],
  CH5: [-3.047899782843052, 53.21532132383907],
  CH6: [-3.115974389626467, 53.24991851070686],
  CH7: [-3.1614941284403635, 53.18504784403668],
  CH8: [-3.2709065405893423, 53.2970472398484],
  CH41: [-3.036655194708068, 53.39373590721399],
  CH42: [-3.0249721512172085, 53.374037794008565],
  CH43: [-3.056771015625, 53.38775109375001],
  CH44: [-3.0470527717724107, 53.41727250767906],
  CH45: [-3.0530059487224457, 53.422845142264535],
  CH46: [-3.108563263089202, 53.400201174044845],
  CH47: [-3.1667068233937514, 53.391511717015376],
  CH48: [-3.1695327019601667, 53.37381083604034],
  CH49: [-3.105136643356643, 53.38277979020979],
  CH60: [-3.104232795361388, 53.3192210027412],
  CH61: [-3.1055777023678224, 53.34749128146667],
  CH62: [-2.985888227396872, 53.33515750383228],
  CH63: [-3.010473800904978, 53.33978357466062],
  CH64: [-3.077417475522051, 53.27939094117637],
  CH65: [-2.905190791631428, 53.28214334375142],
  CH66: [-2.937058763440859, 53.27610322580647],
  EX1: [-3.5028846590909084, 50.726924460227245],
  EX2: [-3.5174234221480125, 50.709306016629],
  EX3: [-3.457722597019746, 50.68553198772292],
  EX4: [-3.5279709065155815, 50.73081059490084],
  EX5: [-3.4512607290540327, 50.75964336187003],
  EX6: [-3.605559821504303, 50.67581465288548],
  EX7: [-3.4757936392987943, 50.587447847577906],
  EX8: [-3.4011536554056314, 50.626800159137154],
  EX9: [-3.312177076777929, 50.644565232953106],
  EX10: [-3.2601562518254936, 50.703934466101785],
  EX11: [-3.292242450980391, 50.73965754901961],
  EX12: [-3.0799725417128436, 50.711492966469734],
  EX13: [-3.009269305555557, 50.795950972222236],
  EX14: [-3.177173409090909, 50.829832670454564],
  EX15: [-3.3149142931937163, 50.87934314136126],
  EX16: [-3.5041477489177493, 50.93660043290045],
  EX17: [-3.729136685714286, 50.825988399999964],
  EX18: [-3.89224584158416, 50.89951584158415],
  EX19: [-4.014563978494622, 50.88491569892473],
  EX20: [-4.054818947368419, 50.769121798245635],
  EX21: [-4.213665971223023, 50.79580992805756],
  EX22: [-4.372326564417177, 50.82500012269935],
  EX23: [-4.563058834336813, 50.826858235130665],
  EX24: [-3.0881942929481454, 50.734398015265505],
  EX31: [-4.035731326023166, 51.114317442581104],
  EX32: [-4.004617919540657, 51.07202329664693],
  EX33: [-4.21494758322153, 51.122591276882396],
  EX34: [-4.115269570738196, 51.20229642033727],
  EX35: [-3.8118115210440555, 51.22993463635027],
  EX36: [-3.769730370370371, 51.016360555555565],
  EX37: [-3.947035398230089, 50.98233061946903],
  EX38: [-4.164268145161291, 50.934311451612906],
  EX39: [-4.418191156530237, 51.042144581057855],
  KY1: [-3.1442448936568814, 56.13030312033607],
  KY2: [-3.1887941085271314, 56.11207565891475],
  KY3: [-3.239556017344667, 56.05247100205411],
  KY4: [-3.368883586956522, 56.11700043478262],
  KY5: [-3.28697578313253, 56.15020843373493],
  KY6: [-3.201417142857142, 56.20058340136054],
  KY7: [-3.1612683749999992, 56.200137125000026],
  KY8: [-2.9911184424661723, 56.20624705044034],
  KY9: [-2.840330717415672, 56.20045619425831],
  KY10: [-2.6868039052379484, 56.238362561410185],
  KY11: [-3.4184402663952635, 56.040421532808516],
  KY12: [-3.5013186573910526, 56.07386771576103],
  KY13: [-3.4528075531914872, 56.19832265957447],
  KY14: [-3.2371760536281156, 56.3358202425374],
  KY15: [-3.046786716924118, 56.31267547007109],
  KY16: [-2.799304603244875, 56.341772067006275],
  OL1: [-2.1133179878048787, 53.55387231707319],
  OL2: [-2.1139257812500003, 53.5710784375],
  OL3: [-2.0178717346938773, 53.55090326530612],
  OL4: [-2.075233025210084, 53.54456760504204],
  OL5: [-2.036713333333333, 53.51584777777777],
  OL6: [-2.087015000000001, 53.49561597938144],
  OL7: [-2.1064120329670346, 53.49090186813186],
  OL8: [-2.1170022549019594, 53.52777931372549],
  OL9: [-2.1471801094890512, 53.53722233576646],
  OL10: [-2.2250815957446806, 53.58915138297872],
  OL11: [-2.1796312171052645, 53.61055065789469],
  OL12: [-2.1707627, 53.63290576666666],
  OL13: [-2.2108891249999996, 53.70188599999999],
  OL14: [-2.1010775000000006, 53.716249722222216],
  OL15: [-2.1026762666666667, 53.64277680000001],
  OL16: [-2.135751650165016, 53.61424204620461],
  SP1: [-1.7948002479338838, 51.07622743801655],
  SP2: [-1.8206971223021586, 51.071082517985616],
  SP3: [-2.012718062499999, 51.11293481250003],
  SP4: [-1.757300183486238, 51.15769275229357],
  SP5: [-1.813555054945054, 51.017146410256416],
  SP6: [-1.8124845454545462, 50.948888909090925],
  SP7: [-2.1814548672566385, 51.00471840707966],
  SP8: [-2.3087729133858295, 51.0375816535433],
  SP9: [-1.669717727272728, 51.22641181818182],
  SP10: [-1.4838337168141589, 51.213272212389406],
  SP11: [-1.4958492642140473, 51.21965230769229],
  WN1: [-2.6295288265306125, 53.565263010204056],
  WN2: [-2.58817663507109, 53.54059142180096],
  WN3: [-2.6437720779220766, 53.53135149350649],
  WN4: [-2.6480599999999987, 53.49300409523807],
  WN5: [-2.6840922981366466, 53.53039559006213],
  WN6: [-2.6748715135135157, 53.57673789189188],
  WN7: [-2.5210626315789484, 53.49856355263158],
  WN8: [-2.765304876033059, 53.560447851239644],
  CM0: [0.8614888717607353, 51.67897777811329],
  CM1: [0.4420146691176471, 51.74945143382352],
  CM2: [0.48793063636363637, 51.7229776818182],
  CM3: [0.655466245301559, 51.687310733676945],
  CM4: [0.3785170481927711, 51.6808331325301],
  CM5: [0.2536897826086958, 51.73192318840577],
  CM6: [0.34115342222222234, 51.865512888888865],
  CM7: [0.5190252054794522, 51.911388173516016],
  CM8: [0.6297086013986019, 51.81687083916082],
  CM9: [0.7633224810343733, 51.73653859038604],
  CM11: [0.45036748691099476, 51.62314010471203],
  CM12: [0.4177550609756097, 51.6222588414634],
  CM13: [0.33711723076923084, 51.607666205128176],
  CM14: [0.27964627551020405, 51.62790311224487],
  CM15: [0.30637956140350875, 51.6428040789474],
  CM16: [0.11769650000000001, 51.70657279999998],
  CM17: [0.15480608695652176, 51.77233369565219],
  CM18: [0.1037857142857143, 51.755313839285726],
  CM19: [0.06955140939597315, 51.75788932885906],
  CM20: [0.10718237410071939, 51.778622230215866],
  CM21: [0.13500985714285715, 51.815925142857125],
  CM22: [0.23156348739495797, 51.86847268907564],
  CM23: [0.15527198347107443, 51.883328016528935],
  CM24: [0.22107289473684213, 51.89275513157894],
  CM77: [0.5673863793103451, 51.87012534482758],
  FK1: [-3.7936744705882335, 55.9776818823529],
  FK2: [-3.7619322691310892, 56.02361122074879],
  FK3: [-3.71187039746335, 56.01560210788986],
  FK4: [-3.9157956179775275, 55.99445000000003],
  FK5: [-3.8259153333333322, 56.02735922222222],
  FK6: [-3.9362353164556954, 56.01966075949366],
  FK7: [-3.898269284857829, 56.10402229295311],
  FK8: [-4.088947992565054, 56.137652565055774],
  FK9: [-3.953540357042303, 56.140047755908206],
  FK10: [-3.7937248645231976, 56.11105472992978],
  FK11: [-3.8485000000000005, 56.1519173076923],
  FK12: [-3.8021013333333338, 56.15933800000001],
  FK13: [-3.7360764516129032, 56.15305903225805],
  FK14: [-3.630743648648648, 56.17570202702702],
  FK15: [-3.934775573770492, 56.21949393442624],
  FK16: [-4.071826842105263, 56.198384210526335],
  FK17: [-4.295358958333333, 56.23606062500002],
  FK18: [-4.32347076923077, 56.32128000000001],
  FK19: [-4.35304225, 56.355399],
  FK20: [-4.622868333333335, 56.409922916666666],
  FK21: [-4.311156944444444, 56.470334722222205],
  L1: [-2.979141315789474, 53.40235388157894],
  L2: [-2.9893121176470587, 53.407557529411775],
  L3: [-2.98252477096059, 53.40482594659719],
  L4: [-2.961366929133857, 53.43673460629919],
  L5: [-2.9760501970443354, 53.42530000000001],
  L6: [-2.9512522926829257, 53.41955146341463],
  L7: [-2.9513928925619846, 53.404722727272706],
  L8: [-2.963686139534882, 53.39205590697677],
  L9: [-2.9509480099502503, 53.46035288557216],
  L10: [-2.9272396078431373, 53.47516480392158],
  L11: [-2.916942795698925, 53.447307688172],
  L12: [-2.8957740825688076, 53.43504509174311],
  L13: [-2.9218020952380956, 53.420230571428554],
  L14: [-2.880808019323671, 53.41886951690823],
  L15: [-2.918466951871658, 53.396506417112356],
  L16: [-2.88658507352941, 53.39810904411769],
  L17: [-2.9372867169639716, 53.378731468424185],
  L18: [-2.905815023041473, 53.37994152073732],
  L19: [-2.904213377761083, 53.36236059658433],
  L20: [-2.988791531250478, 53.45512256576812],
  L21: [-2.9993626864522516, 53.472777924649776],
  L22: [-3.0288768683147493, 53.47877878761312],
  L23: [-3.0261630796843675, 53.48984457578936],
  L24: [-2.841100098858899, 53.34056245749311],
  L25: [-2.865386174863387, 53.37850273224044],
  L26: [-2.83438404494382, 53.365974044943826],
  L27: [-2.8406510294117644, 53.38873014705883],
  L28: [-2.8666647058823536, 53.435368970588236],
  L29: [-2.9870984444444444, 53.5093768888889],
  L30: [-2.9749407299270074, 53.48078072992702],
  L31: [-2.9260121276595754, 53.50675929078013],
  L32: [-2.8895389610389604, 53.4814672077922],
  L33: [-2.8731955263157904, 53.48516736842106],
  L34: [-2.827488055555556, 53.43941061111112],
  L35: [-2.791716993865031, 53.407255030674854],
  L36: [-2.8452214438502677, 53.41627331550805],
  L37: [-3.052311324509333, 53.557201916757286],
  L38: [-3.057106003821586, 53.523029020867845],
  L39: [-2.903358826815644, 53.55585150837987],
  L40: [-2.835892318981938, 53.603376177787844],
  OX1: [-1.2680924324324325, 51.73568806306308],
  OX2: [-1.2857236470588234, 51.758102941176496],
  OX3: [-1.2098282786885244, 51.7697582786885],
  OX4: [-1.215561527777778, 51.73142729166668],
  OX5: [-1.2448051937984494, 51.84028589147288],
  OX7: [-1.5075758048780485, 51.911097756097575],
  OX9: [-0.9994311009174315, 51.72606220183488],
  OX10: [-1.1193388356164382, 51.60315554794524],
  OX11: [-1.2594086363636363, 51.58947659090909],
  OX12: [-1.421796571428571, 51.585743714285734],
  OX13: [-1.3383675722543351, 51.6760547398844],
  OX14: [-1.2560447741935485, 51.660004903225804],
  OX15: [-1.4172994811320758, 52.039975990566035],
  OX16: [-1.3444550537634405, 52.06290795698926],
  OX17: [-1.301621014492754, 52.08043502415459],
  OX18: [-1.596416115107914, 51.76644482014388],
  OX20: [-1.3648163636363644, 51.86635376623379],
  OX25: [-1.2137825268817204, 51.89526198924731],
  OX26: [-1.1530107692307692, 51.90154043956043],
  OX27: [-1.1342087116564419, 51.933519325153355],
  OX28: [-1.4869082954545456, 51.78615943181816],
  OX29: [-1.4637402, 51.79332420000003],
  OX33: [-1.13670045045045, 51.768199639639626],
  OX39: [-0.9198824999999998, 51.699595535714295],
  OX44: [-1.1399374074074073, 51.70329385185184],
  OX49: [-0.9946884615384614, 51.65476098901099],
  SR1: [-1.3753633602743973, 54.906377298510016],
  SR2: [-1.383093417801559, 54.889428868204845],
  SR3: [-1.412028656716418, 54.87974164179102],
  SR4: [-1.4320482557284189, 54.89993800779417],
  SR5: [-1.42039618686509, 54.91841966599078],
  SR6: [-1.3793541518151289, 54.93585868428626],
  SR7: [-1.35598397181852, 54.83073032489062],
  SR8: [-1.3455999850662033, 54.76819548578512],
  WR1: [-2.2228012213740462, 52.195228625954215],
  WR2: [-2.250982571428572, 52.19026049999999],
  WR3: [-2.2070375694444433, 52.21512],
  WR4: [-2.192042177419354, 52.202443306451585],
  WR5: [-2.19932238372093, 52.17554447674419],
  WR6: [-2.3794196566523595, 52.22480991416308],
  WR7: [-2.0541759854014594, 52.191032627737215],
  WR8: [-2.197460238095238, 52.08086190476191],
  WR9: [-2.165473817204301, 52.27205043010753],
  WR10: [-2.0568547199999982, 52.11647056000002],
  WR11: [-1.928752847682119, 52.100143112582764],
  WR12: [-1.8787532307692307, 52.03633800000001],
  WR13: [-2.3274822184300343, 52.09775262798635],
  WR14: [-2.324805333333334, 52.10608607407406],
  WR15: [-2.539370090909091, 52.29962754545457],
  CO1: [0.9119625777844703, 51.887938407680856],
  CO2: [0.8959159317557156, 51.87142474440164],
  CO3: [0.8555371232876707, 51.88681397260276],
  CO4: [0.9222026190476188, 51.914785999999964],
  CO5: [0.8945889219815178, 51.81231875604029],
  CO6: [0.808218961038962, 51.931449155844156],
  CO7: [1.0038665734192243, 51.87615955230733],
  CO8: [0.7614141379310346, 51.973605000000006],
  CO9: [0.5921925477707006, 51.988084713375805],
  CO10: [0.69896025, 52.066191749999966],
  CO11: [1.0863390072473682, 51.94176653413784],
  CO12: [1.2253515134407054, 51.90803856672661],
  CO13: [1.239382348786478, 51.86706757811406],
  CO14: [1.2672657800437137, 51.86211251658785],
  CO15: [1.1479146215073541, 51.80164473409963],
  CO16: [1.1146714145864862, 51.82162913835461],
  FY1: [-3.0405610855702907, 53.814276212409716],
  FY2: [-3.036298562687062, 53.846657984241645],
  FY3: [-3.02089924170616, 53.817846966824646],
  FY4: [-3.0215976894919687, 53.79424806200686],
  FY5: [-3.011338077944163, 53.869490530755265],
  FY6: [-2.975465120547615, 53.87712319127893],
  FY7: [-3.0174886088308694, 53.9080044788213],
  FY8: [-2.963135669984066, 53.743986693003926],
  LA1: [-2.8120323396318727, 54.04431761097187],
  LA2: [-2.7887401133336147, 54.01712161325608],
  LA3: [-2.8594508808052725, 54.02564161708115],
  LA4: [-2.8533747211768237, 54.06790003752267],
  LA5: [-2.8135997013755922, 54.15220174151581],
  LA6: [-2.6267456024096387, 54.17843993975904],
  LA7: [-2.7796951198845745, 54.23180327400181],
  LA8: [-2.7662970112810665, 54.30578131796723],
  LA9: [-2.7397923170731704, 54.331172195121944],
  LA10: [-2.474297301587301, 54.31341809523809],
  LA11: [-2.9692702579192543, 54.18486300441789],
  LA12: [-3.054463609637343, 54.21583942684535],
  LA13: [-3.187604614671548, 54.10198789034171],
  LA14: [-3.235621950331198, 54.115512785139984],
  LA15: [-3.1762834693877555, 54.15817612244897],
  LA16: [-3.2071076527226765, 54.18789200227742],
  LA17: [-3.189805262371227, 54.22793682098567],
  LA18: [-3.2494020722097194, 54.231037785628246],
  LA19: [-3.392573380669978, 54.32332673013522],
  LA20: [-3.212540383952861, 54.28753045046918],
  LA21: [-3.076634347826087, 54.36341695652175],
  LA22: [-2.988323137254903, 54.39365049019609],
  LA23: [-2.916724444444445, 54.36547505050504],
  PA1: [-4.424911624548737, 55.844423249097446],
  PA2: [-4.439609523809525, 55.829199702380926],
  PA3: [-4.446746983187754, 55.85193407987029],
  PA4: [-4.419282448849492, 55.878014789791145],
  PA5: [-4.509690915492958, 55.83286225352112],
  PA6: [-4.534868115942027, 55.86940289855074],
  PA7: [-4.500420295696657, 55.914190110028166],
  PA8: [-4.447105385865884, 55.90199817608422],
  PA9: [-4.55237107142857, 55.80265321428573],
  PA10: [-4.562088571428571, 55.82860333333334],
  PA11: [-4.590746481481482, 55.85691259259259],
  PA12: [-4.623581111111111, 55.79189074074075],
  PA13: [-4.659735686274511, 55.899538627450994],
  PA14: [-4.644048726557082, 55.92542578196757],
  PA15: [-4.747727767729286, 55.942678719171475],
  PA16: [-4.808228473587188, 55.93531843676744],
  PA17: [-4.883792383220432, 55.85255707808556],
  PA18: [-4.885179903253291, 55.885326707807906],
  PA19: [-4.8297816981843305, 55.94879596377368],
  PA20: [-5.082218015884053, 55.79142431638736],
  PA21: [-5.283639509132803, 55.89886894926088],
  PA22: [-5.160583190972692, 55.94678249445797],
  PA23: [-5.002446554869835, 55.96246338579894],
  PA24: [-4.899848939532623, 56.130506742210734],
  PA25: [-5.030776039396585, 56.21333794628775],
  PA26: [-4.936971995921968, 56.26177044015286],
  PA27: [-5.149655440398072, 56.13727245662164],
  PA28: [-5.599031773454877, 55.45026414655532],
  PA29: [-5.523932783252795, 55.77658089870188],
  PA30: [-5.452021436028471, 55.989754015610075],
  PA31: [-5.595533663699601, 56.04589352135784],
  PA32: [-5.1510600379267455, 56.17465533278213],
  PA33: [-5.139673454545455, 56.30937018181818],
  PA34: [-5.601758722779497, 56.31468091530726],
  PA35: [-5.179849599634801, 56.46366494588417],
  PA36: [-4.7580912500000005, 56.519989375],
  PA37: [-5.370303703849777, 56.48221794375106],
  PA38: [-5.334139771964237, 56.587084923070854],
  PA41: [-5.743706309132752, 55.6803230348024],
  PA42: [-6.170314946524025, 55.639132705588096],
  PA43: [-6.3148031517131304, 55.733914014109736],
  PA44: [-6.36015514080724, 55.84474521307097],
  PA45: [-6.119379090373964, 55.81353577622081],
  PA46: [-6.142475527347248, 55.90240540780721],
  PA47: [-6.502922378499457, 55.69473680592984],
  PA48: [-6.415716900459928, 55.725658713525185],
  PA49: [-6.452157138158095, 55.783520062367245],
  PA60: [-5.901037000191668, 55.96683222571427],
  PA61: [-6.220336460661591, 56.05898143009441],
  PA62: [-5.850433883535921, 56.335054469254665],
  PA63: [-5.71881215074159, 56.3720806187577],
  PA64: [-5.667361145589125, 56.43162251802161],
  PA65: [-5.734891927781449, 56.46986825582283],
  PA66: [-6.359234782402923, 56.30181846854506],
  PA67: [-6.234598933153575, 56.30622171814573],
  PA68: [-6.159706080096739, 56.422515017832744],
  PA69: [-6.085208630042036, 56.37634517852757],
  PA70: [-6.029677585853023, 56.352700725669834],
  PA71: [-6.000464859061483, 56.470378912645565],
  PA72: [-5.996633851490192, 56.513764760357894],
  PA73: [-6.255299093788573, 56.47931420216237],
  PA74: [-6.253777624291574, 56.527973791905126],
  PA75: [-6.217448586435596, 56.60056059247096],
  PA76: [-6.424563791268134, 56.32328286607981],
  PA77: [-6.845710542838871, 56.51624828256107],
  PA78: [-6.552546973275391, 56.63249853401784],
  PA80: [-5.837549942833746, 56.58034646286249],
  SS0: [0.687432796720133, 51.54965566183347],
  SS1: [0.7342128534621322, 51.53883820307427],
  SS2: [0.7050868750000002, 51.55478757812499],
  SS3: [0.8364418465925293, 51.573961113429895],
  SS4: [0.7590215872893046, 51.597305785697124],
  SS5: [0.6403043182420255, 51.622877127852355],
  SS6: [0.6066026315789474, 51.587645964912284],
  SS7: [0.5798730707046678, 51.55772924690644],
  SS8: [0.577737995310977, 51.52841218308253],
  SS9: [0.6480823092125445, 51.55086274994912],
  SS11: [0.5597293824494923, 51.622010068180465],
  SS12: [0.5231604000000001, 51.60276248000001],
  SS13: [0.5113050925925927, 51.576306388888895],
  SS14: [0.4767576829268292, 51.575285304878065],
  SS15: [0.4285336879432624, 51.57669099290779],
  SS16: [0.46542236348604926, 51.55777117408874],
  SS17: [0.4610970010388163, 51.51926138865062],
  WS1: [-1.9787832857142869, 52.57697771428574],
  WS2: [-2.0061035960591136, 52.591307881773396],
  WS3: [-1.9879597041420112, 52.61858928994082],
  WS4: [-1.9593771328671314, 52.603104055944065],
  WS5: [-1.9608888495575214, 52.56675513274337],
  WS6: [-2.0222694666666663, 52.658947200000014],
  WS7: [-1.9166990243902435, 52.67781939024391],
  WS8: [-1.9298032500000002, 52.647262250000004],
  WS9: [-1.9153037158469939, 52.60857475409838],
  WS10: [-2.02170824120603, 52.55767638190955],
  WS11: [-2.0149865060240963, 52.68855261044177],
  WS12: [-2.0050605789473672, 52.7035511578948],
  WS13: [-1.8116024757281546, 52.694666165048545],
  WS14: [-1.8269157458563534, 52.65745104972373],
  WS15: [-1.9076168702290075, 52.762237175572515],
  CR0: [-0.07992794425087103, 51.37310857142861],
  CR2: [-0.08154309963099624, 51.35003450184503],
  CR3: [-0.0743498013245033, 51.29275463576156],
  CR4: [-0.15687811111111105, 51.40333596296297],
  CR5: [-0.14832951219512194, 51.308302195121954],
  CR6: [-0.04327288135593221, 51.31002211864409],
  CR7: [-0.10756155963302755, 51.399232110091745],
  CR8: [-0.11417615023474177, 51.33017643192487],
  G1: [-4.250474486304853, 55.85939438722526],
  G2: [-4.257740097087379, 55.86185849514558],
  G3: [-4.280498222640538, 55.86712590861206],
  G4: [-4.2558547081712055, 55.86757439688716],
  G5: [-4.252325517630633, 55.846025899422244],
  G11: [-4.312670377538778, 55.873372622352214],
  G12: [-4.301266774193549, 55.880501451612915],
  G13: [-4.351576077586206, 55.893602974137906],
  G14: [-4.354098389413768, 55.88163110780789],
  G15: [-4.365317589285715, 55.90875508928573],
  G20: [-4.283762909090909, 55.88705990909095],
  G21: [-4.220941747572815, 55.883728932038856],
  G22: [-4.252238896103898, 55.8896531818182],
  G23: [-4.282204146341467, 55.90433524390244],
  G31: [-4.207858879124901, 55.85473837285073],
  G32: [-4.171223338050932, 55.85007117497507],
  G33: [-4.167187387755102, 55.87260040816325],
  G34: [-4.117427499999999, 55.86865934210526],
  G40: [-4.222175635041074, 55.84804425071677],
  G41: [-4.281484176245212, 55.83932203065136],
  G42: [-4.257019865470852, 55.82953973094171],
  G43: [-4.291901770833332, 55.81855635416667],
  G44: [-4.254298467432954, 55.81508034482755],
  G45: [-4.232273235294119, 55.80612215686275],
  G46: [-4.304817257142858, 55.80202359999999],
  G51: [-4.317273572065879, 55.85920574423697],
  G52: [-4.353105251396649, 55.84829106145251],
  G53: [-4.352494285714283, 55.82369187500001],
  G60: [-4.47406712410693, 55.928650493751725],
  G61: [-4.333082302631582, 55.91524815789475],
  G62: [-4.313838783783784, 55.94421554054054],
  G63: [-4.401442352941176, 56.05576372549018],
  G64: [-4.221533834586465, 55.91126157894739],
  G65: [-4.056158076923077, 55.97047192307694],
  G66: [-4.15453313131313, 55.94710707070706],
  G67: [-3.995800692307691, 55.94286038461539],
  G68: [-4.008089115646258, 55.95459346938773],
  G69: [-4.101180050761422, 55.87111121827411],
  G71: [-4.075994850746269, 55.82116246268653],
  G72: [-4.131786478260872, 55.79953969565217],
  G73: [-4.210483824422881, 55.82183857065604],
  G74: [-4.202831508379888, 55.76476329608935],
  G75: [-4.198111692307693, 55.75175307692303],
  G76: [-4.266191587301588, 55.77169243386241],
  G77: [-4.336181212121214, 55.771890909090914],
  G78: [-4.439385161290323, 55.78197731182798],
  G81: [-4.404410796225174, 55.90718783264713],
  G82: [-4.596049719312989, 55.95825729371535],
  G83: [-4.685176506278662, 56.122438253258444],
  G84: [-4.808367331603723, 56.045914115902576],
  LD1: [-3.3622079411764694, 52.28035274509806],
  LD2: [-3.3893704347826086, 52.1369279130435],
  LD3: [-3.3536495000000004, 51.9791040833333],
  LD4: [-3.5583766071428555, 52.10965982142856],
  LD5: [-3.631336, 52.132002250000006],
  LD6: [-3.529828148148149, 52.3164874074074],
  LD7: [-3.1049427710843385, 52.355773012048196],
  LD8: [-3.058325365853659, 52.258686707317075],
  PE1: [-0.23671115107913676, 52.58708561151077],
  PE2: [-0.2606058510638297, 52.55269021276597],
  PE3: [-0.2744935937499999, 52.58497148437498],
  PE4: [-0.26259942622950816, 52.610854508196724],
  PE5: [-0.36643916666666665, 52.57457041666666],
  PE6: [-0.22649574446274992, 52.631855822766404],
  PE7: [-0.2123536178691098, 52.535027870865555],
  PE8: [-0.44976016129032226, 52.522672580645164],
  PE9: [-0.48292629032258066, 52.662528629032245],
  PE10: [-0.37859131868131857, 52.791809670329705],
  PE11: [-0.1664870106992482, 52.80357468565108],
  PE12: [0.05938676375060699, 52.81611425596329],
  PE13: [0.12121367293296323, 52.66528338483626],
  PE14: [0.1957886627874897, 52.653644403981474],
  PE15: [0.07035735294117651, 52.52321460784313],
  PE16: [0.05155209302325581, 52.455593953488375],
  PE19: [-0.27687337748344387, 52.248826158940396],
  PE20: [-0.05097498980922511, 52.92790393604069],
  PE21: [-0.02091827860322401, 52.97034034341842],
  PE22: [0.06778061095619904, 52.99964765364789],
  PE23: [0.09291528925619837, 53.17487727272728],
  PE24: [0.2918302107239063, 53.129315761777015],
  PE25: [0.33597387464109474, 53.1565041183441],
  PE26: [-0.10518307692307689, 52.46568784615385],
  PE27: [-0.06780821428571429, 52.33146053571428],
  PE28: [-0.17873167969669201, 52.35178048360279],
  PE29: [-0.18072987804878052, 52.332124512195115],
  PE30: [0.40435894827137225, 52.7698962928657],
  PE31: [0.6610728447210269, 52.94056653973834],
  PE32: [0.6473038993710692, 52.726748805031434],
  PE33: [0.4622740259740259, 52.64664863636364],
  PE34: [0.3481071362912952, 52.712389171524165],
  PE35: [0.5102426666666667, 52.824625999999995],
  PE36: [0.5693738414063371, 52.962019056390226],
  PE37: [0.7078473563218394, 52.634509310344825],
  PE38: [0.3622397741242443, 52.56925778097637],
  ST1: [-2.17424631016043, 53.029472994652394],
  ST2: [-2.136485628742515, 53.031449880239514],
  ST3: [-2.1231798222222227, 52.98368982222222],
  ST4: [-2.184238474576271, 52.99402972881359],
  ST5: [-2.249197477876106, 53.007247743362825],
  ST6: [-2.184485529953918, 53.058977419354854],
  ST7: [-2.255449336734693, 53.083882142857135],
  ST8: [-2.165455764705882, 53.115112],
  ST9: [-2.0883683660130714, 53.05937895424833],
  ST10: [-1.9471010843373493, 52.99498403614456],
  ST11: [-2.0723800000000003, 52.968895294117644],
  ST12: [-2.1717022641509423, 52.947922641509436],
  ST13: [-2.0083203174603184, 53.095897460317445],
  ST14: [-1.8696726470588236, 52.9114443382353],
  ST15: [-2.1414030841121496, 52.9103143925234],
  ST16: [-2.119380921985817, 52.80871021276595],
  ST17: [-2.085515804878049, 52.78823921951219],
  ST18: [-2.0914415942028977, 52.81522068840581],
  ST19: [-2.152370093457945, 52.70177869158878],
  ST20: [-2.2887297222222225, 52.80491203703701],
  ST21: [-2.276342528735633, 52.87610597701149],
  WV1: [-2.116994493927124, 52.58588607287451],
  WV2: [-2.119661069518716, 52.57400443850268],
  WV3: [-2.1554935678391947, 52.5791623115578],
  WV4: [-2.140641857707511, 52.56189347826086],
  WV5: [-2.244928706896552, 52.53438405172416],
  WV6: [-2.201192242152466, 52.593283811659184],
  WV7: [-2.2747414285714282, 52.6323155102041],
  WV8: [-2.1933318965517254, 52.627086034482765],
  WV9: [-2.15065141509434, 52.63571726415094],
  WV10: [-2.10770342007435, 52.62337669144981],
  WV11: [-2.069335363636365, 52.61371459090909],
  WV12: [-2.0423626896551723, 52.606260068965526],
  WV13: [-2.0626700671140936, 52.58539241610741],
  WV14: [-2.0812730824372747, 52.55583078853048],
  WV15: [-2.3615801324503303, 52.52476576158941],
  WV16: [-2.466267756410255, 52.50445750000001],
  CT1: [1.0847029999999998, 51.27783515384615],
  CT2: [1.082693398452736, 51.29709743195878],
  CT3: [1.1995342667451612, 51.30014593969715],
  CT4: [1.0599456306306303, 51.22019211711712],
  CT5: [1.0241641603946314, 51.34638256583287],
  CT6: [1.1332490177926444, 51.356474732858736],
  CT7: [1.2843087704171958, 51.357796939096005],
  CT8: [1.3342157423541245, 51.37876544969403],
  CT9: [1.388395154302523, 51.37771136082379],
  CT10: [1.4215452964222406, 51.36467594287014],
  CT11: [1.412914190172272, 51.33747594309741],
  CT12: [1.356663437437207, 51.33697569631277],
  CT13: [1.3375993982320291, 51.28154889648328],
  CT14: [1.3453951025969966, 51.221088167299364],
  CT15: [1.2700506437588543, 51.1647328203905],
  CT16: [1.3014102367293057, 51.13803259887228],
  CT17: [1.2971531378452192, 51.12980707403779],
  CT18: [1.1390523878936978, 51.11623834036814],
  CT19: [1.1675086606819447, 51.08739503516267],
  CT20: [1.1611812855758645, 51.083247985393264],
  CT21: [1.056038277741103, 51.081418683424104],
  GL1: [-2.2424206743864574, 51.85923468606081],
  GL2: [-2.292231901572745, 51.83841718752054],
  GL3: [-2.180578011363638, 51.8630418181818],
  GL4: [-2.2061302693602696, 51.836910471380484],
  GL5: [-2.2154421111111104, 51.73067666666667],
  GL6: [-2.197353888888889, 51.73877593750001],
  GL7: [-1.8890899099099092, 51.71419274774772],
  GL8: [-2.1842482, 51.6483923],
  GL9: [-2.3111471578947365, 51.55610621052632],
  GL10: [-2.2883524107142854, 51.74829330357142],
  GL11: [-2.353054482758621, 51.68861712643679],
  GL12: [-2.3986674358974365, 51.61995615384618],
  GL13: [-2.4696844538841995, 51.69312588192021],
  GL14: [-2.434700825917633, 51.80344440039365],
  GL15: [-2.5844048925660927, 51.73282015791554],
  GL16: [-2.614508717948717, 51.79732576923078],
  GL17: [-2.5123253571428585, 51.85810464285715],
  GL18: [-2.422357391304348, 51.952998],
  GL19: [-2.283370238095237, 51.94697327380951],
  GL20: [-2.132020859375, 52.009519140625],
  GL50: [-2.0827826553672306, 51.89984440677961],
  GL51: [-2.105397615658363, 51.89827024911033],
  GL52: [-2.058022388663967, 51.90872866396761],
  GL53: [-2.0675471942446046, 51.87291794964028],
  GL54: [-1.8655129255319143, 51.895532340425554],
  GL55: [-1.7592174999999999, 52.0613682894737],
  GL56: [-1.6942878195488718, 51.991103684210536],
  LE1: [-1.1284019892473116, 52.63354526881719],
  LE2: [-1.117282239130435, 52.6135723043478],
  LE3: [-1.175578983739837, 52.63281642276421],
  LE4: [-1.123549903846154, 52.65969125000001],
  LE5: [-1.090126295081968, 52.63724121311472],
  LE6: [-1.2334180722891563, 52.66568349397589],
  LE7: [-1.079905316804408, 52.67764148760325],
  LE8: [-1.0937127950310557, 52.55519366459628],
  LE9: [-1.2579259793814435, 52.58878907216493],
  LE10: [-1.361488854166667, 52.525130729166676],
  LE11: [-1.2275558666666664, 52.76865159999999],
  LE12: [-1.2022387118644067, 52.76457552542373],
  LE13: [-0.8863805970149258, 52.76348179104477],
  LE14: [-0.8836378151260504, 52.7774769747899],
  LE15: [-0.6801064561359034, 52.66334224979793],
  LE16: [-0.8663372500000003, 52.4957930833333],
  LE17: [-1.1673604511278188, 52.46579691729323],
  LE18: [-1.1137876190476192, 52.58339952380951],
  LE19: [-1.1992759433962263, 52.58955650943394],
  LE65: [-1.4531481707317078, 52.75879585365852],
  LE67: [-1.3601394999999998, 52.71166857142858],
  PH1: [-3.480451534852489, 56.42725649345426],
  PH2: [-3.382483780528488, 56.387525512019025],
  PH3: [-3.69974746835443, 56.31832949367089],
  PH4: [-3.79355935483871, 56.25072322580647],
  PH5: [-3.838618, 56.32529444444443],
  PH6: [-4.034691515151516, 56.3578321212121],
  PH7: [-3.771417088607596, 56.36883481012657],
  PH8: [-3.6550414583333324, 56.56575645833335],
  PH9: [-3.6953409999999995, 56.6459567142857],
  PH10: [-3.4265773333333356, 56.655937238095206],
  PH11: [-3.2466611538461527, 56.666057307692334],
  PH12: [-3.155087499999999, 56.584563571428575],
  PH13: [-3.2778160273972605, 56.5323815068493],
  PH14: [-3.1737505392016008, 56.445390974137574],
  PH15: [-4.049477594936709, 56.60666924050632],
  PH16: [-3.917696575342465, 56.705930684931495],
  PH17: [-4.380901785714287, 56.69222964285713],
  PH18: [-3.9894204166666665, 56.79368791666666],
  PH19: [-4.258727777777778, 56.909528888888886],
  PH20: [-4.272013529411765, 57.047628529411774],
  PH21: [-3.9715615999999994, 57.083653999999996],
  PH22: [-3.7504881481481482, 57.15650999999999],
  PH23: [-3.839016666666667, 57.286573333333344],
  PH24: [-3.7582683333333335, 57.248263333333334],
  PH25: [-3.6350543478260864, 57.23957086956521],
  PH26: [-3.5808759574468083, 57.34348765957447],
  PH30: [-4.666258181818183, 56.78026727272727],
  PH31: [-4.756152352941177, 56.88508588235294],
  PH32: [-4.668229230769231, 57.139661538461525],
  PH33: [-5.291155767713302, 56.75001094654076],
  PH34: [-4.987598125, 56.9509640625],
  PH35: [-5.406009102895319, 57.09678984429836],
  PH36: [-5.928667389344708, 56.726093846139705],
  PH37: [-5.524218421052631, 56.81314842105263],
  PH38: [-5.76302780027446, 56.84790725511091],
  PH39: [-5.866444381297147, 56.905872309988084],
  PH40: [-5.824457010515025, 56.966436735084834],
  PH41: [-5.941751051994011, 57.008166346711235],
  PH42: [-6.158363159068469, 56.892591896478436],
  PH43: [-6.329900398856733, 56.998983815625756],
  PH44: [-6.508781170818674, 57.04145927810328],
  PH49: [-5.106509160301172, 56.647615458580006],
  PH50: [-5.006305158876261, 56.712873787071615],
  SW1A: [-0.1351560486161322, 51.50526130088934],
  SW1E: [-0.1396009459459459, 51.498013108108104],
  SW1H: [-0.1335173913043478, 51.49893434782611],
  SW1P: [-0.13457182303006418, 51.49505163069018],
  SW1V: [-0.13974179487680194, 51.491527190755924],
  SW1W: [-0.15105613732387246, 51.493589296243975],
  SW1X: [-0.1572831395348838, 51.49777459302329],
  SW1Y: [-0.13432446280991736, 51.50818214876035],
  SW2: [-0.11991653979238753, 51.45040411764703],
  SW3: [-0.1674394991636215, 51.49246530418475],
  SW4: [-0.13805215158924197, 51.46107645476774],
  SW5: [-0.19062602739726023, 51.49183684931506],
  SW6: [-0.20390530692632883, 51.481343242906355],
  SW7: [-0.17748849206349215, 51.49536031746035],
  SW8: [-0.13407145001817564, 51.47534486112024],
  SW9: [-0.1138531914893616, 51.46870226950355],
  SW10: [-0.18275042602430602, 51.48490211988964],
  SW11: [-0.16221045150344665, 51.46260448725064],
  SW12: [-0.14921377118644064, 51.446590338983036],
  SW13: [-0.24355467582834167, 51.47243103445114],
  SW14: [-0.2659416294460464, 51.46599405100989],
  SW15: [-0.23004542460846777, 51.45420556031758],
  SW16: [-0.12606504504504515, 51.420387987987986],
  SW17: [-0.16523853479853476, 51.43105798534797],
  SW18: [-0.19268304505929143, 51.45075268723623],
  SW19: [-0.20189501355013545, 51.42441010840105],
  SW20: [-0.22573511520737305, 51.408321751152066],
  YO1: [-1.0795145901639343, 53.957794918032825],
  YO7: [-1.3431308648648648, 54.22542589189187],
  YO8: [-1.0465170092483707, 53.77019120278235],
  YO10: [-1.0598311176470594, 53.95116623529408],
  YO11: [-0.39435972778363365, 54.2618125525218],
  YO12: [-0.4280039505446756, 54.26483811319455],
  YO13: [-0.4876094043892303, 54.313306910149294],
  YO14: [-0.29295798316686944, 54.203239057901854],
  YO15: [-0.15797434448982686, 54.10635411087105],
  YO16: [-0.20653927803871255, 54.098581326253594],
  YO17: [-0.7343727096774194, 54.131291806451614],
  YO18: [-0.7849953684210524, 54.286031157894726],
  YO19: [-1.0507843981363825, 53.89526949488262],
  YO21: [-0.7380901610286198, 54.480508127160604],
  YO22: [-0.6217686808862358, 54.45561367323489],
  YO23: [-1.1326932315245593, 53.91308247893451],
  YO24: [-1.1132383030303035, 53.94939254545456],
  YO25: [-0.4084196732595062, 53.96773476936512],
  YO26: [-1.1954881927710839, 53.98117277108433],
  YO30: [-1.1366139102564101, 53.996436474358994],
  YO31: [-1.0664089671361499, 53.97057399061031],
  YO32: [-1.0551268387096768, 54.0025184516129],
  YO41: [-0.8856244444444447, 53.98177579365078],
  YO42: [-0.7968257031250006, 53.9152125],
  YO43: [-0.689279052631579, 53.83910000000001],
  YO51: [-1.4010775342465749, 54.08444643835615],
  YO60: [-0.9260706422018354, 54.08598229357798],
  YO61: [-1.2160470731707314, 54.13195097560975],
  YO62: [-1.0137583823529415, 54.253575588235286],
  CV1: [-1.507142513966481, 52.410000670391064],
  CV2: [-1.466740597609561, 52.42688382470119],
  CV3: [-1.4864195546558703, 52.39385259109317],
  CV4: [-1.5689479245283033, 52.39632509433961],
  CV5: [-1.553435219123506, 52.411904063745034],
  CV6: [-1.50200395904437, 52.435125972696255],
  CV7: [-1.5453182352941173, 52.45186232352945],
  CV8: [-1.5217429381443301, 52.36487350515464],
  CV9: [-1.5725879562043792, 52.59582817518249],
  CV10: [-1.4933725728155336, 52.52456383495141],
  CV11: [-1.4499610169491528, 52.518432824858735],
  CV12: [-1.4717382945736437, 52.478095271317834],
  CV13: [-1.428586696428571, 52.61236750000001],
  CV21: [-1.2509747899159662, 52.375261470588256],
  CV22: [-1.2648258426966297, 52.363680955056196],
  CV23: [-1.2769032835820886, 52.3671453432836],
  CV31: [-1.525163257575757, 52.27629196969697],
  CV32: [-1.5340626470588234, 52.297617549019584],
  CV33: [-1.4835738728323695, 52.25549554913293],
  CV34: [-1.5688780769230766, 52.277375461538476],
  CV35: [-1.5847202816901405, 52.226791830985896],
  CV36: [-1.61396205479452, 52.056708630136995],
  CV37: [-1.7078719125683068, 52.17181147540981],
  CV47: [-1.3845711475409836, 52.219858114754096],
  GU1: [-0.5607105164319248, 51.24970441314556],
  GU2: [-0.5925312169312171, 51.24612899470901],
  GU3: [-0.6230602439024386, 51.243375325203196],
  GU4: [-0.5403725199999998, 51.25037155999996],
  GU5: [-0.5123542968750003, 51.196661171875],
  GU6: [-0.486583894736842, 51.13477989473684],
  GU7: [-0.6176324468085106, 51.189864468085105],
  GU8: [-0.6411077777777778, 51.147960643274835],
  GU9: [-0.7920138388625589, 51.2148071090048],
  GU10: [-0.7905223969072155, 51.20558479381442],
  GU11: [-0.7571088557213924, 51.25019965174136],
  GU12: [-0.7335558571428569, 51.25078909523809],
  GU14: [-0.7634087349397591, 51.294741144578296],
  GU15: [-0.7341888554216868, 51.33347662650602],
  GU16: [-0.7261552795031055, 51.30964012422362],
  GU17: [-0.7954746774193553, 51.32217879032259],
  GU18: [-0.6720361016949152, 51.34845779661018],
  GU19: [-0.694261724137931, 51.36055275862069],
  GU20: [-0.6623464285714284, 51.372515],
  GU21: [-0.5699468472906402, 51.32266083743845],
  GU22: [-0.5508222790697676, 51.31318637209303],
  GU23: [-0.49643611111111113, 51.29798796296296],
  GU24: [-0.6243093209876538, 51.32666438271606],
  GU25: [-0.5769573529411763, 51.400843235294104],
  GU26: [-0.7560160869565216, 51.11244739130436],
  GU27: [-0.7110547959183673, 51.07633571428569],
  GU28: [-0.6395965384615384, 50.99783057692309],
  GU29: [-0.7651708, 50.98514680000001],
  GU30: [-0.8102801333333332, 51.07103080000002],
  GU31: [-0.9035431147540988, 51.000353715846956],
  GU32: [-0.9709694915254241, 51.013421920903916],
  GU33: [-0.8969047368421051, 51.05766178947366],
  GU34: [-0.9742630769230772, 51.12953521978026],
  GU35: [-0.846404536082474, 51.12259525773195],
  GU46: [-0.8331803508771933, 51.34025175438598],
  GU47: [-0.7913731683168319, 51.34891782178217],
  GU51: [-0.8423142567567566, 51.280281689189216],
  GU52: [-0.8405197000000002, 51.26582650000001],
  LL11: [-3.041404470588232, 53.062853098039255],
  LL12: [-2.985872564102563, 53.07658655677654],
  LL13: [-2.957609896907218, 53.037000343642625],
  LL14: [-3.052268243243244, 52.98789013513517],
  LL15: [-3.3303486813186813, 53.09119538461538],
  LL16: [-3.4578215328467166, 53.184966788321155],
  LL17: [-3.426071204819277, 53.24817975903615],
  LL18: [-3.4638875165455256, 53.297928144113484],
  LL19: [-3.394295652004849, 53.329648341744964],
  LL20: [-3.1666860759493667, 52.95448151898734],
  LL21: [-3.417231869158877, 52.998179719626165],
  LL22: [-3.6105783187510494, 53.24543038209781],
  LL23: [-3.591667916666666, 52.915274583333336],
  LL24: [-3.8057992380952386, 53.06783504761905],
  LL25: [-3.868515869565216, 53.05409239130434],
  LL26: [-3.798499574728462, 53.158093894545836],
  LL27: [-3.8300371273141383, 53.1525681501379],
  LL28: [-3.7770063349589624, 53.269568825114874],
  LL29: [-3.7108386970576888, 53.285680196794864],
  LL30: [-3.819204567642438, 53.31986887523243],
  LL31: [-3.8043480626697526, 53.29331587485734],
  LL32: [-3.840450849476973, 53.24105729775127],
  LL33: [-4.0008358206581045, 53.24277882531012],
  LL34: [-3.9047499263351955, 53.26960003813753],
  LL35: [-3.993957367978114, 52.54849683264821],
  LL36: [-4.059706887610425, 52.61513050664159],
  LL37: [-4.079228830932161, 52.66135659040675],
  LL38: [-4.048339906947736, 52.69603568307648],
  LL39: [-4.01406246588641, 52.717732824182065],
  LL40: [-3.911000484837751, 52.75709362659582],
  LL41: [-3.9742357566688473, 52.94087273254548],
  LL42: [-4.026671527846477, 52.732572654445555],
  LL43: [-4.0802814451713925, 52.77382279819449],
  LL44: [-4.098027311093864, 52.79248504900283],
  LL45: [-4.110584929556532, 52.82530724360925],
  LL46: [-4.1079917084972815, 52.84743022871907],
  LL47: [-4.075778075007306, 52.906225908237886],
  LL48: [-4.0667582949842265, 52.93473112027696],
  LL49: [-4.144203531744548, 52.92222432553517],
  LL51: [-4.221791489361704, 52.976013404255305],
  LL52: [-4.2541213722253195, 52.927384233198694],
  LL53: [-4.622517829895377, 52.84710553761038],
  LL54: [-4.320996658323039, 53.07434895085945],
  LL55: [-4.191973729482876, 53.12220660389956],
  LL56: [-4.204370622171915, 53.18671352598672],
  LL57: [-4.109851410671715, 53.2060400965549],
  LL58: [-4.090731134457914, 53.29782930123983],
  LL59: [-4.162299658424496, 53.23611045301905],
  LL60: [-4.287823492063491, 53.21213476190475],
  LL61: [-4.28545964323744, 53.17854560490947],
  LL62: [-4.409095158477057, 53.18096462962672],
  LL63: [-4.482937186561935, 53.20221079154275],
  LL64: [-4.522703877812697, 53.23177847263491],
  LL65: [-4.593478146831478, 53.30306920508839],
  LL66: [-4.4154849999999985, 53.379887608695654],
  LL67: [-4.476169164864925, 53.41622671591806],
  LL68: [-4.356722500569383, 53.406661668884844],
  LL69: [-4.326535714285713, 53.38236514285714],
  LL70: [-4.280884429032962, 53.369541281964786],
  LL71: [-4.360042753623188, 53.329782318840586],
  LL72: [-4.24339519587761, 53.35385882862815],
  LL73: [-4.238270303325371, 53.337489605730966],
  LL74: [-4.230603875099078, 53.322743435473846],
  LL75: [-4.209273918605752, 53.29143224598095],
  LL76: [-4.243440000000001, 53.300486],
  LL77: [-4.317922798169057, 53.26416683426089],
  LL78: [-4.2702817857142845, 53.31660928571427],
  PL1: [-4.159210762299091, 50.3691363854478],
  PL2: [-4.164508928303754, 50.389243269181094],
  PL3: [-4.12946755205734, 50.38689333940486],
  PL4: [-4.129621817973085, 50.375609890880334],
  PL5: [-4.165112099531607, 50.41715091233946],
  PL6: [-4.118897936433932, 50.42025954890433],
  PL7: [-4.036268539325842, 50.40498595505619],
  PL8: [-4.0171906871851135, 50.316005807276035],
  PL9: [-4.098576061651559, 50.33849305271202],
  PL10: [-4.207095657038245, 50.33689732391514],
  PL11: [-4.271644820016177, 50.37458305342878],
  PL12: [-4.263745157139329, 50.41838648463582],
  PL13: [-4.492399138107395, 50.351406927267895],
  PL14: [-4.481646544117648, 50.454966985294135],
  PL15: [-4.428651851851853, 50.635991185185176],
  PL16: [-4.252407624999999, 50.65199225000003],
  PL17: [-4.3007169786868, 50.51901526775694],
  PL18: [-4.214114029427747, 50.5090649494316],
  PL19: [-4.176913825550557, 50.56313617306686],
  PL20: [-4.144623708328492, 50.48388447715612],
  PL21: [-3.910521128870649, 50.37227291217252],
  PL22: [-4.640817057789185, 50.38968105596782],
  PL23: [-4.626369084813189, 50.33649649537735],
  PL24: [-4.694354101931171, 50.33930265760554],
  PL25: [-4.775094410485186, 50.34112812607766],
  PL26: [-4.80136535949679, 50.28981290986438],
  PL27: [-4.90802210196169, 50.53241422722573],
  PL28: [-4.994870927642163, 50.5376005938821],
  PL29: [-4.835650663281927, 50.591068543771485],
  PL30: [-4.751943714019184, 50.501192983321324],
  PL31: [-4.722796307692309, 50.46861169230767],
  PL32: [-4.642815714285716, 50.64657879120878],
  PL33: [-4.755944969278338, 50.620350286251956],
  PL34: [-4.749313832255295, 50.66210595960127],
  PL35: [-4.686926723585561, 50.691272937387076],
  SY1: [-2.743178092105264, 52.719059934210506],
  SY2: [-2.7326294776119417, 52.70471335820895],
  SY3: [-2.7735025462962954, 52.69913689814816],
  SY4: [-2.7312346913580248, 52.78051540123457],
  SY5: [-2.81034605015674, 52.6599410031348],
  SY6: [-2.777007962962964, 52.5372711111111],
  SY7: [-2.886749567099569, 52.43330636363637],
  SY8: [-2.6895591999999997, 52.37021059999999],
  SY9: [-2.9888670114942544, 52.50285655172416],
  SY10: [-3.1092311246200635, 52.84589349544073],
  SY11: [-3.015263655462187, 52.879785084033635],
  SY12: [-2.8961125000000014, 52.90245051724137],
  SY13: [-2.698282513089005, 52.95079921465968],
  SY14: [-2.7647524999999993, 53.037938175675684],
  SY15: [-3.122388925619836, 52.54598338842976],
  SY16: [-3.3055685039370095, 52.532824251968506],
  SY17: [-3.472036071428571, 52.50847511904761],
  SY18: [-3.5504346551724137, 52.4351648275862],
  SY19: [-3.6441540909090904, 52.57276181818183],
  SY20: [-3.9203877098040896, 52.56685148476073],
  SY21: [-3.2379903980099485, 52.66111139303483],
  SY22: [-3.1911704929577462, 52.75182042253521],
  SY23: [-4.0500626005736065, 52.35519809677235],
  SY24: [-4.01708486750134, 52.496171802671896],
  SY25: [-3.949547699999999, 52.24386330000002],
  ZE1: [-1.2249809073904039, 60.15303878170143],
  ZE2: [-1.2517871065823192, 60.359241744736565],
  ZE3: [-1.308996212880165, 59.87483660213137],
} as Record<PostcodeDistrict, [number, number]>
